import { z as e } from "@hono/zod-openapi";
//#region src/types/BaseEntity.ts
var t = e.object({
	created_at: e.string(),
	updated_at: e.string()
}), n = e.enum([
	"local",
	"shared",
	"platform"
]), r = e.enum([
	"none",
	"secrets",
	"fields"
]), i = {
	scope: n.optional(),
	override: r.optional(),
	enforce: e.boolean().optional()
}, a = e.object({
	id: e.string(),
	version: e.string().optional()
}), o = e.object({
	name: e.string(),
	version: e.string()
}), s = e.object({
	name: e.string(),
	value: e.string().optional()
}), c = e.object({
	name: e.string().max(255),
	code: e.string().max(1e5),
	supported_triggers: e.array(a).optional(),
	runtime: e.string().max(50).optional(),
	dependencies: e.array(o).optional(),
	secrets: e.array(s).optional(),
	is_system: e.boolean().optional(),
	...i,
	inherit: e.boolean().optional()
}), ee = c.partial().extend({
	status: e.enum(["draft", "built"]).optional(),
	deployed_at: e.string().optional()
}), te = c.extend({
	id: e.string(),
	tenant_id: e.string(),
	status: e.enum(["draft", "built"]).default("built"),
	deployed_at: e.string().optional(),
	secrets: e.array(e.object({
		name: e.string(),
		value: e.string().optional()
	})).optional()
}).extend(t.shape), ne = e.object({ name: e.string() }), re = te.extend({ secrets: e.array(ne).optional() }), ie = e.string(), ae = e.enum([
	"unspecified",
	"pending",
	"final",
	"partial",
	"canceled",
	"suspended"
]), oe = e.object({
	id: e.string(),
	msg: e.string(),
	url: e.string().optional()
}), se = e.object({
	action_name: e.string(),
	error: oe.nullable(),
	started_at: e.string(),
	ended_at: e.string()
}), ce = e.object({
	level: e.enum([
		"log",
		"info",
		"warn",
		"error",
		"debug"
	]),
	message: e.string()
}), le = e.array(e.object({
	action_name: e.string(),
	lines: e.array(ce)
})), ue = e.object({
	id: e.string(),
	tenant_id: e.string(),
	trigger_id: ie,
	status: ae,
	results: e.array(se),
	logs: le.optional(),
	created_at: e.string(),
	updated_at: e.string()
}), de = ue.omit({
	tenant_id: !0,
	created_at: !0,
	updated_at: !0
}), fe = e.object({
	action_id: e.string(),
	code: e.string().max(1e5),
	runtime: e.string().max(50).optional(),
	dependencies: e.array(o).optional(),
	secrets: e.array(s).optional(),
	supported_triggers: e.array(a).optional(),
	deployed: e.boolean().default(!0)
}), pe = fe.extend({
	id: e.string(),
	tenant_id: e.string(),
	number: e.number().int()
}).extend(t.shape), me = e.enum([
	"user_action",
	"admin_action",
	"system",
	"api"
]), he = e.object({
	type: e.enum([
		"user",
		"admin",
		"system",
		"api_key",
		"client_credentials"
	]),
	id: e.string().optional(),
	email: e.string().optional(),
	org_id: e.string().optional(),
	org_name: e.string().optional(),
	scopes: e.array(e.string()).optional(),
	client_id: e.string().optional()
}), ge = e.object({
	type: e.string(),
	id: e.string(),
	before: e.record(e.string(), e.unknown()).optional(),
	after: e.record(e.string(), e.unknown()).optional(),
	diff: e.record(e.string(), e.object({
		old: e.unknown(),
		new: e.unknown()
	})).optional()
}), _e = e.object({
	user: e.object({
		user_id: e.string(),
		name: e.string().optional(),
		email: e.string().optional()
	}).optional(),
	strategy: e.string(),
	credentials: e.object({
		jti: e.string().optional(),
		scopes: e.array(e.string()).optional()
	}).optional()
}), ve = e.object({
	method: e.string(),
	path: e.string(),
	query: e.record(e.string(), e.string()).optional(),
	body: e.unknown().optional(),
	ip: e.string(),
	user_agent: e.string().optional(),
	correlation_id: e.string().optional(),
	redirect_uri: e.string().optional(),
	authorization_url: e.string().optional(),
	auth: _e.optional()
}), ye = e.object({
	status_code: e.number(),
	body: e.unknown().optional()
}), be = e.object({
	country_code: e.string(),
	city_name: e.string(),
	latitude: e.string(),
	longitude: e.string(),
	time_zone: e.string(),
	continent_code: e.string()
}), xe = e.object({
	name: e.string(),
	version: e.string(),
	env: e.record(e.string(), e.string()).optional()
}), Se = e.object({
	tenant_id: e.string(),
	event_type: e.string(),
	log_type: e.string(),
	description: e.string().optional(),
	category: me,
	actor: he,
	target: ge,
	request: ve,
	response: ye.optional(),
	connection: e.string().optional(),
	connection_id: e.string().optional(),
	client_name: e.string().optional(),
	strategy: e.string().optional(),
	strategy_type: e.string().optional(),
	audience: e.string().optional(),
	scope: e.string().optional(),
	location: be.optional(),
	auth0_client: xe.optional(),
	hostname: e.string(),
	is_mobile: e.boolean().optional(),
	execution_id: e.string().optional(),
	details: e.record(e.string(), e.unknown()).optional(),
	login_session_id: e.string().optional(),
	timestamp: e.string()
}), Ce = Se.extend({ id: e.string() }), we = e.enum([
	"AUTH0",
	"EMAIL",
	"REDIRECT"
]), Te = e.enum([
	"CREATE_USER",
	"GET_USER",
	"UPDATE_USER",
	"SEND_REQUEST",
	"SEND_EMAIL"
]), Ee = e.enum(["VERIFY_EMAIL"]), De = e.object({
	require_mx_record: e.boolean().optional(),
	block_aliases: e.boolean().optional(),
	block_free_emails: e.boolean().optional(),
	block_disposable_emails: e.boolean().optional(),
	blocklist: e.array(e.string()).optional(),
	allowlist: e.array(e.string()).optional()
}), Oe = e.object({
	id: e.string(),
	alias: e.string().max(100).optional(),
	type: e.literal("AUTH0"),
	action: e.literal("UPDATE_USER"),
	allow_failure: e.boolean().optional(),
	mask_output: e.boolean().optional(),
	params: e.object({
		connection_id: e.string().optional(),
		user_id: e.string(),
		changes: e.record(e.string(), e.any())
	})
}), ke = e.object({
	id: e.string(),
	alias: e.string().max(100).optional(),
	type: e.literal("EMAIL"),
	action: e.literal("VERIFY_EMAIL"),
	allow_failure: e.boolean().optional(),
	mask_output: e.boolean().optional(),
	params: e.object({
		email: e.string(),
		rules: De.optional()
	})
}), Ae = e.enum([
	"change-email",
	"account",
	"custom"
]), je = e.object({
	id: e.string(),
	alias: e.string().max(100).optional(),
	type: e.literal("REDIRECT"),
	action: e.literal("REDIRECT_USER"),
	allow_failure: e.boolean().optional(),
	mask_output: e.boolean().optional(),
	params: e.object({
		target: Ae.openapi({ description: "The predefined target to redirect to, or 'custom' for a custom URL" }),
		custom_url: e.string().optional().openapi({ description: "Custom URL to redirect to when target is 'custom'" })
	})
}), Me = e.union([
	Oe,
	ke,
	je
]), Ne = e.object({
	name: e.string().min(1).max(150).openapi({ description: "The name of the flow" }),
	actions: e.array(Me).optional().default([]).openapi({ description: "The list of actions to execute in sequence" })
}), Pe = Ne.extend(t.shape).extend({ id: e.string().openapi({
	description: "Unique identifier for the flow",
	example: "af_12tMpdJ3iek7svMyZkSh5M"
}) }), Fe = e.object({
	page: e.string().min(0).optional().default("0").transform((e) => parseInt(e, 10)).openapi({ description: "The page number where 0 is the first page" }),
	per_page: e.string().min(1).optional().default("50").transform((e) => parseInt(e, 10)).openapi({ description: "The number of items per page. Defaults to 50." }),
	include_totals: e.string().optional().default("false").transform((e) => e === "true").openapi({ description: "If the total number of items should be included in the response" }),
	sort: e.string().regex(/^.+:(-1|1)$/).optional().openapi({ description: "A property that should have the format 'string:-1' or 'string:1'" }),
	q: e.string().optional().openapi({ description: "A lucene query string used to filter the results" })
}), Ie = e.object({
	start: e.number(),
	limit: e.number(),
	length: e.number(),
	total: e.number().optional(),
	next: e.string().optional()
}), l = e.object({
	email: e.string().optional(),
	email_verified: e.boolean().optional(),
	name: e.string().optional(),
	username: e.string().optional(),
	given_name: e.string().optional(),
	phone_number: e.string().optional(),
	phone_verified: e.boolean().optional(),
	family_name: e.string().optional()
}).catchall(e.any()), u = e.object({
	connection: e.string(),
	user_id: e.string(),
	provider: e.string(),
	isSocial: e.boolean(),
	email: e.string().optional(),
	email_verified: e.boolean().optional(),
	phone_number: e.string().optional(),
	phone_verified: e.boolean().optional(),
	username: e.string().optional(),
	access_token: e.string().optional(),
	access_token_secret: e.string().optional(),
	refresh_token: e.string().optional(),
	profileData: l.optional()
}), d = e.object({
	formatted: e.string().optional(),
	street_address: e.string().optional(),
	locality: e.string().optional(),
	region: e.string().optional(),
	postal_code: e.string().optional(),
	country: e.string().optional()
}).optional(), f = e.object({
	email: e.string().transform((e) => e.toLowerCase()).optional(),
	username: e.string().refine((e) => !e.includes("@"), { message: "Usernames must not contain \"@\". Use the email field for email addresses." }).optional(),
	phone_number: e.string().optional(),
	phone_verified: e.boolean().optional(),
	given_name: e.string().optional(),
	family_name: e.string().optional(),
	nickname: e.string().optional(),
	name: e.string().optional(),
	picture: e.string().optional(),
	locale: e.string().optional(),
	linked_to: e.string().optional(),
	profileData: e.string().optional(),
	user_id: e.string().optional(),
	app_metadata: e.any().default({}).optional(),
	user_metadata: e.any().default({}).optional(),
	middle_name: e.string().optional(),
	preferred_username: e.string().optional(),
	profile: e.string().optional(),
	website: e.string().optional(),
	gender: e.string().optional(),
	birthdate: e.string().optional(),
	zoneinfo: e.string().optional(),
	address: d
}), p = f.extend({
	email_verified: e.boolean().default(!1),
	verify_email: e.boolean().optional(),
	last_ip: e.string().optional(),
	last_login: e.string().optional(),
	user_id: e.string().optional(),
	provider: e.string().optional(),
	connection: e.string(),
	is_social: e.boolean().optional(),
	blocked: e.boolean().optional(),
	registration_completed_at: e.string().optional(),
	password: e.object({
		hash: e.string(),
		algorithm: e.string()
	}).optional()
}), m = p.omit({ password: !0 }).extend(t.shape).extend({
	user_id: e.string(),
	provider: e.string(),
	is_social: e.boolean(),
	email: e.string().optional(),
	login_count: e.number().default(0),
	identities: e.array(u).optional()
}), Le = m.omit({ registration_completed_at: !0 }), Re = f.extend({
	login_count: e.number(),
	multifactor: e.array(e.string()).optional(),
	last_ip: e.string().optional(),
	last_login: e.string().optional(),
	user_id: e.string()
}).catchall(e.any()), ze = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", Be = (e = 21) => {
	let t = "", n = crypto.getRandomValues(new Uint8Array(e |= 0));
	for (; e--;) t += ze[n[e] & 63];
	return t;
}, h = e.object({
	client_id: e.string().optional().openapi({ description: "ID of this client. Generated server-side if omitted (Auth0 behavior)." }),
	name: e.string().min(1).openapi({ description: "Name of this client (min length: 1 character, does not allow < or >)." }),
	description: e.string().max(140).optional().openapi({ description: "Free text description of this client (max length: 140 characters)." }),
	global: e.boolean().default(!1).openapi({ description: "Whether this is your global 'All Applications' client representing legacy tenant settings (true) or a regular client (false)." }),
	client_secret: e.string().default(() => Be()).optional().openapi({ description: "Client secret (which you must not make public)." }),
	app_type: e.enum([
		"native",
		"spa",
		"regular_web",
		"non_interactive",
		"resource_server",
		"express_configuration",
		"rms",
		"box",
		"cloudbees",
		"concur",
		"dropbox",
		"mscrm",
		"echosign",
		"egnyte",
		"newrelic",
		"office365",
		"salesforce",
		"sentry",
		"sharepoint",
		"slack",
		"springcm",
		"zendesk",
		"zoom",
		"sso_integration",
		"oag"
	]).default("regular_web").optional().openapi({ description: "The type of application this client represents" }),
	logo_uri: e.string().url().optional().openapi({ description: "URL of the logo to display for this client. Recommended size is 150x150 pixels." }),
	is_first_party: e.boolean().default(!0).openapi({ description: "Whether this client is a first party client (true) or not (false). First-party clients skip the consent screen; third-party clients require explicit user consent for non-basic scopes." }),
	oidc_conformant: e.boolean().default(!0).openapi({ description: "Whether this client conforms to strict OIDC specifications (true) or uses legacy features (false)." }),
	auth0_conformant: e.boolean().default(!0).openapi({ description: "Whether this client follows Auth0-compatible behavior (true) or strict OIDC behavior (false). When true, profile/email claims are included in the ID token when scopes are requested. When false, these claims are only available from the userinfo endpoint (strict OIDC 5.4 compliance)." }),
	callbacks: e.array(e.string()).default([]).optional().openapi({ description: "Comma-separated list of URLs whitelisted for Auth0 to use as a callback to the client after authentication." }),
	allowed_origins: e.array(e.string()).default([]).optional().openapi({ description: "Comma-separated list of URLs allowed to make requests from JavaScript to Auth0 API (typically used with CORS). By default, all your callback URLs will be allowed. This field allows you to enter other origins if necessary. You can also use wildcards at the subdomain level (e.g., https://*.contoso.com). Query strings and hash information are not taken into account when validating these URLs." }),
	web_origins: e.array(e.string()).default([]).optional().openapi({ description: "Comma-separated list of allowed origins for use with Cross-Origin Authentication, Device Flow, and web message response mode." }),
	client_aliases: e.array(e.string()).default([]).optional().openapi({ description: "List of audiences/realms for SAML protocol. Used by the wsfed addon." }),
	allowed_clients: e.array(e.string()).default([]).optional().openapi({ description: "List of allow clients and API ids that are allowed to make delegation requests. Empty means all all your clients are allowed." }),
	connections: e.array(e.string()).default([]).optional().openapi({ description: "List of connection IDs enabled for this client. The order determines the display order on the login page." }),
	allowed_logout_urls: e.array(e.string()).default([]).optional().openapi({ description: "Comma-separated list of URLs that are valid to redirect to after logout from Auth0. Wildcards are allowed for subdomains." }),
	session_transfer: e.record(e.string(), e.any()).default({}).optional().openapi({ description: "Native to Web SSO Configuration" }),
	oidc_logout: e.object({
		backchannel_logout_urls: e.array(e.string()).optional().openapi({ description: "URLs that receive a signed OIDC Back-Channel Logout 1.0 logout token when a session this client participated in ends." }),
		backchannel_logout_initiators: e.object({
			mode: e.enum(["all", "custom"]).optional().openapi({ description: "Whether all session-end events initiate a backchannel logout (all) or only the selected_initiators (custom)." }),
			selected_initiators: e.array(e.string()).optional().openapi({ description: "Logout initiators that trigger a backchannel logout when mode is custom (e.g. rp-logout, idp-logout, password-changed)." })
		}).passthrough().optional().openapi({ description: "Controls which session-end events initiate backchannel logout notifications. Stored for Auth0 compatibility; not yet enforced — all initiators currently notify." })
	}).passthrough().default({}).optional().openapi({ description: "Configuration for OIDC backchannel logout" }),
	grant_types: e.array(e.string()).default([]).optional().openapi({ description: "List of grant types supported for this application. Can include authorization_code, implicit, refresh_token, client_credentials, password, http://auth0.com/oauth/grant-type/password-realm, http://auth0.com/oauth/grant-type/mfa-oob, http://auth0.com/oauth/grant-type/mfa-otp, http://auth0.com/oauth/grant-type/mfa-recovery-code, urn:openid:params:grant-type:ciba, and urn:ietf:params:oauth:grant-type:device_code." }),
	jwt_configuration: e.record(e.string(), e.any()).default({}).optional().openapi({ description: "Configuration related to JWTs for the client." }),
	signing_keys: e.array(e.record(e.string(), e.any())).default([]).optional().openapi({ description: "Signing certificates associated with this client." }),
	encryption_key: e.record(e.string(), e.any()).default({}).optional().openapi({ description: "Encryption used for WsFed responses with this client." }),
	sso: e.boolean().default(!1).openapi({ description: "Applies only to SSO clients and determines whether Auth0 will handle Single Sign On (true) or whether the Identity Provider will (false)." }),
	sso_disabled: e.boolean().default(!1).openapi({ description: "Whether Single Sign On is disabled for this client. When true, existing SSO sessions will not be reused and users must authenticate every time." }),
	cross_origin_authentication: e.boolean().default(!1).openapi({ description: "Whether this client can be used to make cross-origin authentication requests (true) or it is not allowed to make such requests (false)." }),
	cross_origin_loc: e.string().url().optional().openapi({ description: "URL of the location in your site where the cross origin verification takes place for the cross-origin auth flow when performing Auth in your own domain instead of Auth0 hosted login page." }),
	custom_login_page_on: e.boolean().default(!1).openapi({ description: "Whether a custom login page is to be used (true) or the default provided login page (false)." }),
	custom_login_page: e.string().optional().openapi({ description: "The content (HTML, CSS, JS) of the custom login page." }),
	custom_login_page_preview: e.string().optional().openapi({ description: "The content (HTML, CSS, JS) of the custom login page. (Used on Previews)" }),
	form_template: e.string().optional().openapi({ description: "HTML form template to be used for WS-Federation." }),
	addons: e.record(e.string(), e.any()).default({}).optional().openapi({ description: "Addons enabled for this client and their associated configurations." }),
	token_endpoint_auth_method: e.enum([
		"none",
		"client_secret_post",
		"client_secret_basic",
		"client_secret_jwt",
		"private_key_jwt"
	]).default("client_secret_basic").optional().openapi({ description: "Defines the requested authentication method for the token endpoint. `none` (public client), `client_secret_post` / `client_secret_basic` (HTTP POST / Basic), `client_secret_jwt` (RFC 7523 HMAC assertion using client_secret), or `private_key_jwt` (RFC 7523 asymmetric assertion verified against the client's `jwks` / `jwks_uri`)." }),
	client_metadata: e.record(e.string(), e.string().max(255)).default({}).optional().openapi({ description: "Metadata associated with the client, in the form of an object with string values (max 255 chars). Maximum of 10 metadata properties allowed. Field names (max 255 chars) are alphanumeric and may only include the following special characters: :,-+=_*?\"/()<>@ [Tab][Space]" }),
	hide_sign_up_disabled_error: e.boolean().default(!1).optional().openapi({ description: "Enumeration-safe variant of the connection-level `disable_signup` flag. When a signup is blocked by the password connection and this is true, the identifier screen does not reveal that an email is unknown — it advances to the OTP/password challenge as if the account existed and fails at credential check. Mitigates email enumeration at the cost of UX: users without an account see a generic credential failure instead of an explicit signup-disabled message." }),
	mobile: e.record(e.string(), e.any()).default({}).optional().openapi({ description: "Additional configuration for native mobile apps." }),
	initiate_login_uri: e.string().url().optional().openapi({ description: "Initiate login uri, must be https" }),
	native_social_login: e.record(e.string(), e.any()).default({}).optional(),
	refresh_token: e.object({
		rotation_type: e.enum(["rotating", "non-rotating"]).optional().openapi({ description: "Whether refresh tokens for this client are rotated on every exchange (Auth0 'rotating' behavior) or kept stable (legacy non-rotating). Defaults to 'non-rotating' when unset." }),
		leeway: e.number().int().min(0).max(600).optional().openapi({ description: "Seconds after a parent token's first rotation during which presenting it again still mints a fresh sibling child instead of triggering reuse-detection. Defaults to 30s when unset." }),
		expiration_type: e.enum(["expiring", "non-expiring"]).optional().openapi({ description: "Whether refresh tokens for this client expire at all. 'non-expiring' overrides both the absolute and the idle lifetime." }),
		token_lifetime: e.number().int().min(0).optional().openapi({ description: "Refresh-token absolute lifetime in seconds. Falls back to the tenant's `session_lifetime` when unset." }),
		infinite_token_lifetime: e.boolean().optional().openapi({ description: "When true, refresh tokens have no absolute expiry (overrides `token_lifetime`)." }),
		idle_token_lifetime: e.number().int().min(0).optional().openapi({ description: "Refresh-token idle (sliding) lifetime in seconds, refreshed on every exchange. Falls back to the tenant's `idle_session_lifetime` when unset." }),
		infinite_idle_token_lifetime: e.boolean().optional().openapi({ description: "When true, refresh tokens have no idle expiry (overrides `idle_token_lifetime`)." })
	}).default({}).optional().openapi({ description: "Refresh token configuration" }),
	default_organization: e.record(e.string(), e.any()).default({}).optional().openapi({ description: "Defines the default Organization ID and flows" }),
	organization_usage: e.enum([
		"deny",
		"allow",
		"require"
	]).default("deny").optional().openapi({ description: "Defines how to proceed during an authentication transaction with regards an organization. Can be deny (default), allow or require." }),
	organization_require_behavior: e.enum([
		"no_prompt",
		"pre_login_prompt",
		"post_login_prompt"
	]).default("no_prompt").optional().openapi({ description: "Defines how to proceed during an authentication transaction when client.organization_usage: 'require'. Can be no_prompt (default), pre_login_prompt or post_login_prompt. post_login_prompt requires oidc_conformant: true." }),
	client_authentication_methods: e.record(e.string(), e.any()).default({}).optional().openapi({ description: "Defines client authentication methods." }),
	require_pushed_authorization_requests: e.boolean().default(!1).openapi({ description: "Makes the use of Pushed Authorization Requests mandatory for this client" }),
	require_proof_of_possession: e.boolean().default(!1).openapi({ description: "Makes the use of Proof-of-Possession mandatory for this client" }),
	signed_request_object: e.record(e.string(), e.any()).default({}).optional().openapi({ description: "JWT-secured Authorization Requests (JAR) settings." }),
	compliance_level: e.enum([
		"none",
		"fapi1_adv_pkj_par",
		"fapi1_adv_mtls_par",
		"fapi2_sp_pkj_mtls",
		"fapi2_sp_mtls_mtls"
	]).optional().openapi({ description: "Defines the compliance level for this client, which may restrict it's capabilities" }),
	par_request_expiry: e.number().optional().openapi({ description: "Specifies how long, in seconds, a Pushed Authorization Request URI remains valid" }),
	token_quota: e.record(e.string(), e.any()).default({}).optional(),
	owner_user_id: e.string().optional().openapi({ description: "User ID of the consenting user when this client was created via IAT-gated Dynamic Client Registration. NULL for clients created via the Management API or open DCR." }),
	registration_type: e.enum([
		"manual",
		"open_dcr",
		"iat_dcr"
	]).optional().openapi({ description: "Provenance of this client. `manual` = Management API; `open_dcr` = RFC 7591 without IAT; `iat_dcr` = RFC 7591 with an Initial Access Token." }),
	registration_metadata: e.record(e.string(), e.any()).default({}).optional().openapi({ description: "Arbitrary metadata captured at Dynamic Client Registration time that isn't a first-class client field (e.g. integration_type, domain). Also stores `iat_constraints` for clients created via IAT so RFC 7592 PUT can enforce field immutability." }),
	token_exchange: e.object({ allow_any_profile_of_type: e.array(e.literal("custom_authentication")).optional() }).optional().openapi({ description: "Custom Token Exchange settings. Set `allow_any_profile_of_type` to `[\"custom_authentication\"]` to let this client exchange subject tokens through the tenant's token exchange profiles." }),
	user_linking_mode: e.enum(["builtin", "off"]).optional().openapi({ description: "Per-client override for the built-in email-based user-linking path. `builtin` runs the legacy in-process linking at user creation/email update. `off` disables the legacy path; linking only happens if the tenant has enabled the `account-linking` template hook. When unset, the service-level `userLinkingMode` default applies." })
}), Ve = e.object({
	created_at: e.string(),
	updated_at: e.string()
}).extend(h.shape).extend({ client_id: e.string() }), g = e.object({
	client_id: e.string().min(1).openapi({ description: "ID of the client." }),
	audience: e.string().min(1).openapi({ description: "The audience (API identifier) of this client grant." }),
	scope: e.array(e.string()).optional().openapi({ description: "Scopes allowed for this client grant." }),
	organization_usage: e.enum([
		"deny",
		"allow",
		"require"
	]).optional().openapi({ description: "Defines whether organizations can be used with client credentials exchanges for this grant." }),
	allow_any_organization: e.boolean().optional().openapi({ description: "If enabled, any organization can be used with this grant. If disabled (default), the grant must be explicitly assigned to the desired organizations." }),
	is_system: e.boolean().optional().openapi({ description: "If enabled, this grant is a special grant created by Auth0. It cannot be modified or deleted directly." }),
	subject_type: e.enum(["client", "user"]).optional().openapi({ description: "The type of application access the client grant allows. Use of this field is subject to the applicable Free Trial terms in Okta's Master Subscription Agreement." }),
	authorization_details_types: e.array(e.string()).optional().openapi({ description: "Types of authorization_details allowed for this client grant. Use of this field is subject to the applicable Free Trial terms in Okta's Master Subscription Agreement." })
}), _ = e.object({ id: e.string().openapi({ description: "ID of the client grant." }) }).extend(g.shape).extend({
	created_at: e.string().optional(),
	updated_at: e.string().optional()
}), He = e.array(_), v = e.enum(["iat", "rat"]), Ue = e.object({
	id: e.string(),
	token_hash: e.string(),
	type: v,
	client_id: e.string().optional(),
	sub: e.string().optional(),
	constraints: e.record(e.string(), e.unknown()).optional(),
	single_use: e.boolean().default(!1),
	expires_at: e.string().optional()
}), We = e.object({
	created_at: e.string(),
	used_at: e.string().optional(),
	revoked_at: e.string().optional()
}).extend(Ue.shape), y = e.object({
	x: e.number(),
	y: e.number()
}), Ge = /* @__PURE__ */ function(e) {
	return e.RICH_TEXT = "RICH_TEXT", e.NEXT_BUTTON = "NEXT_BUTTON", e.BACK_BUTTON = "BACK_BUTTON", e.SUBMIT_BUTTON = "SUBMIT_BUTTON", e.DIVIDER = "DIVIDER", e.TEXT = "TEXT", e.EMAIL = "EMAIL", e.PASSWORD = "PASSWORD", e.NUMBER = "NUMBER", e.PHONE = "PHONE", e.DATE = "DATE", e.CHECKBOX = "CHECKBOX", e.RADIO = "RADIO", e.SELECT = "SELECT", e.HIDDEN = "HIDDEN", e.LEGAL = "LEGAL", e;
}({}), Ke = /* @__PURE__ */ function(e) {
	return e.BLOCK = "BLOCK", e.FIELD = "FIELD", e;
}({}), b = e.object({
	id: e.string(),
	category: e.nativeEnum(Ke),
	type: e.nativeEnum(Ge)
}), qe = b.extend({
	category: e.literal("BLOCK"),
	type: e.literal("RICH_TEXT"),
	config: e.object({ content: e.string() }).passthrough()
}), Je = b.extend({
	category: e.literal("BLOCK"),
	type: e.union([
		e.literal("NEXT_BUTTON"),
		e.literal("BACK_BUTTON"),
		e.literal("SUBMIT_BUTTON")
	]),
	config: e.object({ text: e.string() }).passthrough()
}), Ye = b.extend({
	category: e.literal("FIELD"),
	type: e.literal("LEGAL"),
	required: e.boolean().optional(),
	sensitive: e.boolean().optional(),
	config: e.object({ text: e.string() }).passthrough()
}), Xe = b.extend({
	category: e.literal("FIELD"),
	type: e.union([
		e.literal("TEXT"),
		e.literal("EMAIL"),
		e.literal("PASSWORD"),
		e.literal("NUMBER"),
		e.literal("PHONE"),
		e.literal("DATE"),
		e.literal("CHECKBOX"),
		e.literal("RADIO"),
		e.literal("SELECT"),
		e.literal("HIDDEN")
	]),
	required: e.boolean().optional(),
	sensitive: e.boolean().optional(),
	config: e.object({
		label: e.string().optional(),
		placeholder: e.string().optional()
	}).passthrough()
}), Ze = e.object({
	id: e.string(),
	category: e.string(),
	type: e.string()
}).passthrough(), Qe = e.union([
	qe,
	Je,
	Ye,
	Xe,
	Ze
]), $e = /* @__PURE__ */ function(e) {
	return e.STEP = "STEP", e.FLOW = "FLOW", e.CONDITION = "CONDITION", e.ACTION = "ACTION", e;
}({}), et = e.object({
	id: e.string(),
	type: e.literal("STEP"),
	coordinates: y,
	alias: e.string().optional(),
	config: e.object({
		components: e.array(Qe),
		next_node: e.string()
	}).passthrough()
}), tt = e.object({
	id: e.string(),
	type: e.literal("FLOW"),
	coordinates: y,
	alias: e.string().optional(),
	config: e.object({
		flow_id: e.string(),
		next_node: e.string()
	})
}), nt = e.object({
	id: e.string(),
	type: e.literal("ACTION"),
	coordinates: y,
	alias: e.string().optional(),
	config: e.object({
		action_type: e.enum(["REDIRECT"]).openapi({ description: "The type of action to perform" }),
		target: e.enum([
			"change-email",
			"account",
			"custom"
		]).openapi({ description: "The predefined target to redirect to" }),
		custom_url: e.string().optional().openapi({ description: "Custom URL when target is 'custom'" }),
		next_node: e.string().openapi({ description: "The next node to navigate to after action (for non-redirect actions)" })
	}).passthrough()
}), rt = e.object({
	id: e.string(),
	type: e.string(),
	coordinates: y
}).passthrough(), it = e.union([
	et,
	tt,
	nt,
	rt
]), at = e.object({
	next_node: e.string(),
	coordinates: y
}).passthrough(), ot = e.object({
	resume_flow: e.boolean().optional(),
	coordinates: y
}).passthrough(), st = e.object({
	id: e.string(),
	name: e.string(),
	languages: e.object({ primary: e.string() }).passthrough(),
	nodes: e.array(it),
	start: at,
	ending: ot,
	created_at: e.string(),
	updated_at: e.string(),
	links: e.object({
		sdkSrc: e.string().optional(),
		sdk_src: e.string().optional()
	}).passthrough()
}).passthrough(), ct = st.omit({
	id: !0,
	created_at: !0,
	updated_at: !0
}), x = /* @__PURE__ */ function(e) {
	return e.TOKEN = "token", e.ID_TOKEN = "id_token", e.TOKEN_ID_TOKEN = "id_token token", e.CODE = "code", e.CODE_ID_TOKEN = "code id_token", e.CODE_TOKEN = "code token", e.CODE_ID_TOKEN_TOKEN = "code id_token token", e;
}({}), S = /* @__PURE__ */ function(e) {
	return e.QUERY = "query", e.FRAGMENT = "fragment", e.FORM_POST = "form_post", e.WEB_MESSAGE = "web_message", e.SAML_POST = "saml_post", e;
}({}), lt = /* @__PURE__ */ function(e) {
	return e.S256 = "S256", e.Plain = "plain", e;
}({}), ut = e.union([e.null(), e.object({
	essential: e.boolean().optional(),
	value: e.unknown().optional(),
	values: e.array(e.unknown()).optional()
})]).nullable(), dt = e.object({
	userinfo: e.record(e.string(), ut).optional(),
	id_token: e.record(e.string(), ut).optional()
}), ft = e.object({
	client_id: e.string(),
	act_as: e.string().optional(),
	response_type: e.nativeEnum(x).optional(),
	response_mode: e.nativeEnum(S).optional(),
	redirect_uri: e.string().optional(),
	audience: e.string().optional(),
	organization: e.string().optional(),
	state: e.string().optional(),
	nonce: e.string().optional(),
	scope: e.string().optional(),
	prompt: e.string().optional(),
	code_challenge_method: e.nativeEnum(lt).optional(),
	code_challenge: e.string().optional(),
	username: e.string().optional(),
	ui_locales: e.string().optional(),
	max_age: e.number().optional(),
	acr_values: e.string().optional(),
	claims: dt.optional(),
	vendor_id: e.string().optional()
}), pt = e.object({
	...i,
	colors: e.object({
		primary: e.string(),
		page_background: e.union([e.string(), e.object({
			type: e.string().optional(),
			start: e.string().optional(),
			end: e.string().optional(),
			angle_deg: e.number().optional()
		})]).optional()
	}).optional(),
	logo_url: e.string().optional(),
	favicon_url: e.string().optional(),
	powered_by_logo_url: e.string().optional(),
	font: e.object({ url: e.string() }).optional(),
	dark_mode: e.enum([
		"dark",
		"light",
		"auto"
	]).optional()
}), mt = e.enum([
	"password_reset",
	"email_verification",
	"otp",
	"mfa_otp",
	"authorization_code",
	"oauth2_state",
	"ticket",
	"client_assertion_jti",
	"subject_token_jti"
]), ht = e.object({
	code_id: e.string().openapi({ description: "The code that will be used in for instance an email verification flow" }),
	login_id: e.string().optional().openapi({ description: "The id of the login session that the code is connected to" }),
	connection_id: e.string().optional().openapi({ description: "The connection that the code is connected to" }),
	code_type: mt,
	code_verifier: e.string().optional().openapi({ description: "The code verifier used in PKCE in outbound flows" }),
	code_challenge: e.string().optional().openapi({ description: "The code challenge used in PKCE in outbound flows" }),
	code_challenge_method: e.enum(["plain", "S256"]).optional().openapi({ description: "The code challenge method used in PKCE in outbound flows" }),
	redirect_uri: e.string().optional().openapi({ description: "The redirect URI associated with the code" }),
	otp: e.string().optional().openapi({ description: "The one-time password value for OTP-based flows" }),
	nonce: e.string().optional().openapi({ description: "The nonce value used for security in OIDC flows" }),
	state: e.string().optional().openapi({ description: "The state parameter used for CSRF protection in OAuth flows" }),
	expires_at: e.string(),
	used_at: e.string().optional(),
	user_id: e.string().optional()
}), gt = ht.extend({ created_at: e.string() }), _t = e.object({
	device_code_hash: e.string(),
	user_code_hash: e.string(),
	client_id: e.string(),
	scope: e.string().optional(),
	audience: e.string().optional(),
	status: e.enum([
		"pending",
		"approved",
		"denied",
		"consumed"
	]),
	login_id: e.string().optional(),
	expires_at: e.string(),
	created_at: e.string(),
	last_polled_at: e.string().optional(),
	interval: e.number().int().positive(),
	version: e.number().int().nonnegative()
}), vt = e.object({
	kid: e.string().optional(),
	team_id: e.string().optional(),
	realms: e.string().optional(),
	authentication_method: e.string().optional(),
	client_id: e.string().optional(),
	client_secret: e.string().optional(),
	app_secret: e.string().optional(),
	scope: e.string().optional(),
	client_secret_hint: e.string().optional(),
	app_secret_hint: e.string().optional(),
	twilio_token_hint: e.string().optional(),
	authorization_endpoint: e.string().optional(),
	token_endpoint: e.string().optional(),
	userinfo_endpoint: e.string().optional(),
	jwks_uri: e.string().optional(),
	discovery_url: e.string().optional(),
	issuer: e.string().optional(),
	token_endpoint_auth_method: e.enum(["client_secret_basic", "client_secret_post"]).optional(),
	provider: e.string().optional(),
	from: e.string().optional(),
	twilio_sid: e.string().optional(),
	twilio_token: e.string().optional(),
	icon_url: e.string().optional(),
	domain_aliases: e.array(e.string()).optional(),
	callback_url: e.string().url().optional(),
	passwordPolicy: e.enum([
		"none",
		"low",
		"fair",
		"good",
		"excellent"
	]).optional(),
	password_complexity_options: e.object({ min_length: e.number().optional() }).optional(),
	password_history: e.object({
		enable: e.boolean().optional(),
		size: e.number().optional()
	}).optional(),
	password_no_personal_info: e.object({ enable: e.boolean().optional() }).optional(),
	password_dictionary: e.object({
		enable: e.boolean().optional(),
		dictionary: e.array(e.string()).optional()
	}).optional(),
	disable_signup: e.boolean().optional(),
	brute_force_protection: e.boolean().optional(),
	import_mode: e.boolean().optional(),
	configuration: e.object({
		token_endpoint: e.string().optional(),
		userinfo_endpoint: e.string().optional(),
		client_id: e.string().optional(),
		client_secret: e.string().optional(),
		client_secret_hint: e.string().optional(),
		realm: e.string().optional()
	}).optional(),
	attributes: e.object({
		email: e.object({
			identifier: e.object({ active: e.boolean().optional() }).optional(),
			signup: e.object({
				status: e.enum([
					"required",
					"optional",
					"disabled"
				]).optional(),
				verification: e.object({ active: e.boolean().optional() }).optional()
			}).optional(),
			validation: e.object({ allowed: e.boolean().optional() }).optional(),
			unique: e.boolean().optional(),
			profile_required: e.boolean().optional(),
			verification_method: e.enum(["link", "code"]).optional()
		}).optional(),
		username: e.object({
			identifier: e.object({ active: e.boolean().optional() }).optional(),
			signup: e.object({ status: e.enum([
				"required",
				"optional",
				"disabled"
			]).optional() }).optional(),
			validation: e.object({
				max_length: e.number().optional(),
				min_length: e.number().optional(),
				allowed_types: e.object({
					email: e.boolean().optional(),
					phone_number: e.boolean().optional()
				}).optional()
			}).optional(),
			profile_required: e.boolean().optional()
		}).optional(),
		phone_number: e.object({
			identifier: e.object({ active: e.boolean().optional() }).optional(),
			signup: e.object({ status: e.enum([
				"required",
				"optional",
				"disabled"
			]).optional() }).optional()
		}).optional()
	}).optional(),
	authentication_methods: e.object({
		password: e.object({ enabled: e.boolean().optional() }).optional(),
		passkey: e.object({ enabled: e.boolean().optional() }).optional()
	}).optional(),
	passkey_options: e.object({
		challenge_ui: e.enum([
			"both",
			"autofill",
			"button"
		]).optional(),
		local_enrollment_enabled: e.boolean().optional(),
		progressive_enrollment_enabled: e.boolean().optional()
	}).optional(),
	requires_username: e.boolean().optional(),
	validation: e.object({ username: e.object({
		min: e.number().optional(),
		max: e.number().optional()
	}).optional() }).optional(),
	set_user_root_attributes: e.enum([
		"on_each_login",
		"on_first_login",
		"never_on_login"
	]).optional()
});
function C(e) {
	if (e !== null) {
		if (Array.isArray(e)) return e.filter((e) => e !== null).map(C);
		if (e && typeof e == "object") {
			let t = {};
			for (let [n, r] of Object.entries(e)) r !== null && (t[n] = C(r));
			return t;
		}
		return e;
	}
}
var yt = e.object({
	id: e.string().optional(),
	name: e.string(),
	display_name: e.string().optional(),
	strategy: e.string(),
	options: e.preprocess((e) => e === null ? {} : C(e), vt).default({}),
	enabled_clients: e.array(e.string()).default([]).optional(),
	response_type: e.nativeEnum(x).optional(),
	response_mode: e.nativeEnum(S).optional(),
	is_domain_connection: e.boolean().optional(),
	show_as_button: e.boolean().optional(),
	metadata: e.record(e.string(), e.any()).optional(),
	is_system: e.boolean().optional(),
	...i
}), bt = e.object({
	id: e.string(),
	created_at: e.string().transform((e) => e === null ? "" : e),
	updated_at: e.string().transform((e) => e === null ? "" : e)
}).extend(yt.shape), w = e.object({
	domain: e.string(),
	custom_domain_id: e.string().optional(),
	type: e.enum(["auth0_managed_certs", "self_managed_certs"]),
	verification_method: e.enum(["txt"]).optional(),
	tls_policy: e.enum(["recommended"]).optional(),
	custom_client_ip_header: e.enum([
		"true-client-ip",
		"cf-connecting-ip",
		"x-forwarded-for",
		"x-azure-clientip",
		"null"
	]).optional(),
	domain_metadata: e.record(e.string(), e.string().max(255)).optional()
}), xt = e.discriminatedUnion("name", [e.object({
	name: e.literal("txt"),
	record: e.string(),
	domain: e.string()
}), e.object({
	name: e.literal("http"),
	http_body: e.string(),
	http_url: e.string()
})]), St = w.extend({
	custom_domain_id: e.string(),
	primary: e.boolean(),
	status: e.enum([
		"disabled",
		"pending",
		"pending_verification",
		"ready"
	]),
	origin_domain_name: e.string().optional(),
	verification: e.object({ methods: e.array(xt) }).optional(),
	tls_policy: e.string().optional()
}), Ct = w.pick({
	tls_policy: !0,
	custom_client_ip_header: !0,
	domain_metadata: !0
}).strict(), wt = St.extend({ tenant_id: e.string() }), Tt = e.object({
	certificate: e.string().regex(/^-----BEGIN CERTIFICATE-----[\s\S]+-----END CERTIFICATE-----\s*$/, "must be PEM-encoded; include the full certificate chain in leaf-first order"),
	private_key: e.string().regex(/-----BEGIN (RSA |EC |ENCRYPTED )?PRIVATE KEY-----[\s\S]+-----END \1PRIVATE KEY-----\s*$/, "must be a PEM-encoded private key")
}), T = e.object({
	id: e.string(),
	order: e.number().optional(),
	visible: e.boolean().optional().default(!0)
}), E = T.extend({ category: e.literal("BLOCK").optional() }), Et = E.extend({
	type: e.literal("DIVIDER"),
	config: e.object({ text: e.string().optional() }).optional()
}), Dt = E.extend({
	type: e.literal("HTML"),
	config: e.object({ content: e.string().optional() }).optional()
}), Ot = E.extend({
	type: e.literal("IMAGE"),
	config: e.object({
		src: e.string().optional(),
		alt: e.string().optional(),
		width: e.number().optional(),
		height: e.number().optional()
	}).optional()
}), kt = E.extend({
	type: e.literal("JUMP_BUTTON"),
	config: e.object({
		text: e.string().optional(),
		target_step: e.string().optional()
	})
}), At = E.extend({
	type: e.literal("RESEND_BUTTON"),
	config: e.object({
		text: e.string().optional(),
		resend_action: e.string().optional()
	})
}), jt = E.extend({
	type: e.literal("NEXT_BUTTON"),
	config: e.object({
		text: e.string().optional(),
		variant: e.enum(["primary", "secondary"]).optional(),
		skip_validation: e.boolean().optional()
	})
}), Mt = E.extend({
	type: e.literal("PREVIOUS_BUTTON"),
	config: e.object({ text: e.string().optional() })
}), Nt = E.extend({
	type: e.literal("RICH_TEXT"),
	config: e.object({ content: e.string().optional() }).optional()
}), D = T.extend({
	category: e.literal("WIDGET").optional(),
	label: e.string().min(1).optional(),
	hint: e.string().min(1).max(500).optional(),
	required: e.boolean().optional(),
	sensitive: e.boolean().optional()
}), Pt = D.extend({
	type: e.literal("AUTH0_VERIFIABLE_CREDENTIALS"),
	config: e.object({ credential_type: e.string().optional() })
}), Ft = D.extend({
	type: e.literal("GMAPS_ADDRESS"),
	config: e.object({ api_key: e.string().optional() })
}), It = D.extend({
	type: e.literal("RECAPTCHA"),
	config: e.object({ site_key: e.string().optional() })
}), O = T.extend({
	category: e.literal("FIELD").optional(),
	label: e.string().min(1).optional(),
	hint: e.string().min(1).max(500).optional(),
	messages: e.array(e.object({
		id: e.number().optional(),
		text: e.string(),
		type: e.enum([
			"info",
			"error",
			"success",
			"warning"
		])
	})).optional(),
	required: e.boolean().optional(),
	sensitive: e.boolean().optional()
}), Lt = O.extend({
	type: e.literal("BOOLEAN"),
	config: e.object({ default_value: e.boolean().optional() }).optional()
}), Rt = O.extend({
	type: e.literal("CARDS"),
	config: e.object({
		options: e.array(e.object({
			value: e.string(),
			label: e.string(),
			description: e.string().optional(),
			image: e.string().optional()
		})).optional(),
		multi_select: e.boolean().optional()
	}).optional()
}), zt = O.extend({
	type: e.literal("CHOICE"),
	config: e.object({
		options: e.array(e.object({
			value: e.string(),
			label: e.string()
		})).optional(),
		display: e.enum(["radio", "checkbox"]).optional(),
		multiple: e.boolean().optional(),
		default_value: e.union([e.string(), e.array(e.string())]).optional()
	}).optional()
}), Bt = O.extend({
	type: e.literal("CODE"),
	config: e.object({
		length: e.number().int().positive().max(100).optional(),
		mode: e.enum(["numeric", "alphanumeric"]).optional(),
		auto_submit: e.boolean().optional(),
		group_size: e.number().int().min(0).max(100).optional(),
		separator: e.string().optional(),
		placeholder: e.string().optional(),
		default_value: e.string().optional()
	}).refine((e) => e.group_size === void 0 || e.length === void 0 || e.group_size <= e.length, {
		message: "group_size cannot exceed length",
		path: ["group_size"]
	}).refine((e) => e.default_value === void 0 || e.length === void 0 || e.default_value.length <= e.length, {
		message: "default_value is longer than the configured length",
		path: ["default_value"]
	}).optional()
}), Vt = O.extend({
	type: e.literal("CUSTOM"),
	config: e.object({
		component: e.string().optional(),
		props: e.record(e.string(), e.any()).optional(),
		schema: e.record(e.string(), e.any()).optional(),
		code: e.string().optional()
	})
}), Ht = O.extend({
	type: e.literal("DATE"),
	config: e.object({
		format: e.string().optional(),
		min: e.string().optional(),
		max: e.string().optional(),
		default_value: e.string().optional()
	}).optional()
}), Ut = O.extend({
	type: e.literal("DROPDOWN"),
	config: e.object({
		options: e.array(e.object({
			value: e.string(),
			label: e.string()
		})).optional(),
		placeholder: e.string().optional(),
		searchable: e.boolean().optional(),
		multiple: e.boolean().optional(),
		default_value: e.union([e.string(), e.array(e.string())]).optional()
	}).optional()
}), Wt = O.extend({
	type: e.literal("EMAIL"),
	config: e.object({
		placeholder: e.string().optional(),
		default_value: e.string().optional(),
		last_used: e.boolean().optional(),
		last_used_label: e.string().optional()
	}).optional()
}), Gt = O.extend({
	type: e.literal("FILE"),
	config: e.object({
		accept: e.string().optional(),
		max_size: e.number().optional(),
		multiple: e.boolean().optional()
	}).optional()
}), Kt = O.extend({
	type: e.literal("LEGAL"),
	config: e.object({
		text: e.string(),
		html: e.boolean().optional()
	}).optional()
}), qt = O.extend({
	type: e.literal("NUMBER"),
	config: e.object({
		placeholder: e.string().optional(),
		min: e.number().optional(),
		max: e.number().optional(),
		step: e.number().optional(),
		default_value: e.string().optional()
	}).optional()
}), Jt = O.extend({
	type: e.literal("PASSWORD"),
	config: e.object({
		placeholder: e.string().optional(),
		min_length: e.number().optional(),
		show_toggle: e.boolean().optional(),
		forgot_password_link: e.string().optional(),
		default_value: e.string().optional()
	}).optional()
}), Yt = O.extend({
	type: e.literal("PAYMENT"),
	config: e.object({
		provider: e.string().optional(),
		currency: e.string().optional()
	}).optional()
}), Xt = O.extend({
	type: e.literal("SOCIAL"),
	config: e.object({
		providers: e.array(e.string()).optional(),
		provider_details: e.array(e.object({
			name: e.string(),
			strategy: e.string().optional(),
			display_name: e.string().optional(),
			short_name: e.string().optional(),
			icon_url: e.string().optional(),
			href: e.string().optional(),
			last_used: e.boolean().optional(),
			last_used_label: e.string().optional()
		})).optional()
	}).optional()
}), Zt = O.extend({
	type: e.literal("TEL"),
	config: e.object({
		placeholder: e.string().optional(),
		default_country: e.string().optional(),
		default_value: e.string().optional(),
		allow_email: e.boolean().optional()
	}).optional()
}), Qt = O.extend({
	type: e.literal("TEXT"),
	config: e.object({
		placeholder: e.string().optional(),
		multiline: e.boolean().optional(),
		max_length: e.number().optional(),
		default_value: e.string().optional(),
		last_used: e.boolean().optional(),
		last_used_label: e.string().optional()
	}).optional()
}), $t = O.extend({
	type: e.literal("COUNTRY"),
	config: e.object({
		placeholder: e.string().optional(),
		default_value: e.string().optional()
	}).optional()
}), en = O.extend({
	type: e.literal("URL"),
	config: e.object({
		placeholder: e.string().optional(),
		default_value: e.string().optional()
	}).optional()
}), tn = e.discriminatedUnion("type", [
	Et,
	Dt,
	Ot,
	kt,
	At,
	jt,
	Mt,
	Nt
]), nn = e.discriminatedUnion("type", [
	Pt,
	Ft,
	It
]), rn = e.discriminatedUnion("type", [
	Lt,
	Rt,
	zt,
	Bt,
	$t,
	Vt,
	Ht,
	Ut,
	Wt,
	Gt,
	Kt,
	qt,
	Jt,
	Yt,
	Xt,
	Zt,
	Qt,
	en
]), k = e.union([
	tn,
	nn,
	rn
]), an = new Set([
	"BOOLEAN",
	"CARDS",
	"CHOICE",
	"CODE",
	"COUNTRY",
	"DATE",
	"DROPDOWN",
	"EMAIL",
	"LEGAL",
	"NUMBER",
	"PASSWORD",
	"TEL",
	"TEXT",
	"URL"
]), on = e.object({
	id: e.string(),
	type: e.literal("submit"),
	label: e.string(),
	className: e.string().optional(),
	disabled: e.boolean().optional().default(!1),
	order: e.number().optional(),
	visible: e.boolean().optional().default(!0),
	customizations: e.record(e.string(), e.any()).optional()
}), A = e.object({
	x: e.number(),
	y: e.number()
}), sn = e.object({
	id: e.string(),
	type: e.literal("FLOW"),
	coordinates: A,
	alias: e.string().min(1).max(150).optional(),
	config: e.object({
		flow_id: e.string().max(30),
		next_node: e.string().optional()
	})
}), cn = e.object({
	id: e.string(),
	type: e.literal("ROUTER"),
	coordinates: A,
	alias: e.string().min(1).max(150),
	config: e.object({
		rules: e.array(e.object({
			id: e.string(),
			alias: e.string().min(1).max(150).optional(),
			condition: e.any(),
			next_node: e.string()
		})),
		fallback: e.string()
	})
}), ln = e.object({
	id: e.string(),
	type: e.literal("STEP"),
	coordinates: A,
	alias: e.string().min(1).max(150).optional(),
	config: e.object({
		components: e.array(k),
		next_node: e.string().optional()
	})
}), un = e.discriminatedUnion("type", [
	sn,
	cn,
	ln
]), dn = e.object({
	name: e.string().openapi({ description: "The name of the form" }),
	messages: e.object({
		errors: e.record(e.string(), e.any()).optional(),
		custom: e.record(e.string(), e.any()).optional()
	}).optional(),
	languages: e.object({
		primary: e.string().optional(),
		default: e.string().optional()
	}).optional(),
	translations: e.record(e.string(), e.any()).optional(),
	nodes: e.array(un).optional(),
	start: e.object({
		hidden_fields: e.array(e.object({
			key: e.string(),
			value: e.string()
		})).optional(),
		next_node: e.string().optional(),
		coordinates: A.optional()
	}).optional(),
	ending: e.object({
		redirection: e.object({
			delay: e.number().optional(),
			target: e.string().optional()
		}).optional(),
		after_submit: e.object({ flow_id: e.string().optional() }).optional(),
		coordinates: A.optional(),
		resume_flow: e.boolean().optional()
	}).optional(),
	style: e.object({ css: e.string().optional() }).optional(),
	links: e.object({
		sdkSrc: e.string().optional(),
		sdk_src: e.string().optional()
	}).optional()
}).openapi({ description: "Schema for flow-based forms (matches Auth0 Forms structure)" }), fn = t.extend(dn.shape).extend({ id: e.string() }), pn = e.object({
	id: e.number().optional(),
	text: e.string(),
	type: e.enum([
		"info",
		"error",
		"success",
		"warning"
	])
}), mn = e.object({
	id: e.string().optional(),
	text: e.string(),
	href: e.string(),
	linkText: e.string().optional()
}), hn = e.object({
	"form-content-start": e.string().optional(),
	"form-content-end": e.string().optional(),
	"form-footer-start": e.string().optional(),
	"form-footer-end": e.string().optional(),
	"secondary-actions-start": e.string().optional(),
	"secondary-actions-end": e.string().optional()
}).strict(), gn = e.object({
	name: e.string().optional(),
	action: e.string(),
	method: e.enum(["POST", "GET"]),
	title: e.string().optional(),
	description: e.string().optional(),
	components: e.array(k),
	messages: e.array(pn).optional(),
	links: e.array(mn).optional(),
	partials: hn.optional(),
	footer: e.string().optional()
});
function _n(e) {
	return e.category === "BLOCK";
}
function vn(e) {
	return e.category === "WIDGET";
}
function yn(e) {
	return e.category === "FIELD";
}
//#endregion
//#region src/types/Hook.ts
var j = e.enum([
	"pre-user-registration",
	"post-user-registration",
	"post-user-login",
	"post-user-update",
	"validate-registration-username",
	"pre-user-deletion",
	"post-user-deletion"
]), M = e.enum(["post-user-login"]), N = e.enum([
	"post-user-login",
	"post-user-registration",
	"post-user-update",
	"credentials-exchange"
]), P = e.enum([
	"validate-registration-username",
	"post-user-login",
	"credentials-exchange",
	"pre-user-registration",
	"post-user-registration",
	"pre-user-update",
	"post-user-update",
	"pre-user-deletion",
	"post-user-deletion"
]), F = e.enum(["post-user-login"]), bn = [
	{
		field: "url",
		triggers: j.options
	},
	{
		field: "form_id",
		triggers: M.options
	},
	{
		field: "template_id",
		triggers: N.options
	},
	{
		field: "code_id",
		triggers: P.options
	},
	{
		field: "page_id",
		triggers: F.options
	}
];
function xn(e) {
	if (!(!e || typeof e != "object")) {
		for (let t of bn) if (typeof Reflect.get(e, t.field) == "string") return t.triggers;
	}
}
var I = e.enum(["impersonate"]), L = e.enum([
	"ensure-username",
	"set-preferred-username",
	"account-linking"
]), Sn = {
	"ensure-username": {
		name: "Ensure Username",
		description: "Automatically assigns a username to users who sign in without one. Creates a linked username account for social/email users.",
		trigger_ids: ["post-user-login"]
	},
	"set-preferred-username": {
		name: "Set Preferred Username",
		description: "Sets the preferred_username claim on tokens based on the username from the primary or linked user.",
		trigger_ids: ["credentials-exchange"]
	},
	"account-linking": {
		name: "Account Linking",
		description: "Links a user to an existing primary account with the same verified email. Idempotent — safe to run on every login, registration, and email update.",
		trigger_ids: [
			"post-user-login",
			"post-user-registration",
			"post-user-update"
		]
	}
}, R = {
	enabled: e.boolean().default(!1),
	synchronous: e.boolean().default(!1),
	priority: e.number().optional(),
	hook_id: e.string().optional(),
	metadata: e.record(e.string(), e.unknown()).optional(),
	...i
}, Cn = e.object({
	...R,
	trigger_id: j,
	url: e.string()
}), wn = e.object({
	...R,
	trigger_id: M,
	form_id: e.string()
}), Tn = e.object({
	...R,
	trigger_id: N,
	template_id: L
}), En = e.object({
	...R,
	trigger_id: P,
	code_id: e.string()
}), Dn = e.object({
	...R,
	trigger_id: F,
	page_id: I,
	permission_required: e.string().optional()
}), On = e.union([
	Cn,
	wn,
	Tn,
	En,
	Dn
]), kn = e.object({
	...R,
	trigger_id: j
}).extend(t.shape).extend({
	hook_id: e.string(),
	url: e.string()
}), An = e.object({
	...R,
	trigger_id: M
}).extend(t.shape).extend({
	hook_id: e.string(),
	form_id: e.string()
}), jn = e.object({
	...R,
	trigger_id: N
}).extend(t.shape).extend({
	hook_id: e.string(),
	template_id: L
}), Mn = e.object({
	...R,
	trigger_id: P
}).extend(t.shape).extend({
	hook_id: e.string(),
	code_id: e.string()
}), Nn = e.object({
	...R,
	trigger_id: F
}).extend(t.shape).extend({
	hook_id: e.string(),
	page_id: I,
	permission_required: e.string().optional()
}), Pn = e.union([
	kn,
	An,
	jn,
	Mn,
	Nn
]), Fn = e.object({
	code: e.string().max(1e5),
	secrets: e.record(e.string(), e.string()).optional()
}), In = Fn.extend({
	id: e.string(),
	tenant_id: e.string()
}).extend(t.shape), Ln = e.object({ name: e.string().optional() }), Rn = e.object({ email: e.string().optional() }), zn = e.object({
	id: e.string().optional(),
	organization_id: e.string().max(50),
	inviter: Ln,
	invitee: Rn,
	invitation_url: e.string().url(),
	client_id: e.string(),
	connection_id: e.string().optional(),
	app_metadata: e.record(e.string(), e.any()).default({}).optional(),
	user_metadata: e.record(e.string(), e.any()).default({}).optional(),
	ttl_sec: e.number().int().max(2592e3).default(604800).optional(),
	roles: e.array(e.string()).default([]).optional(),
	send_invitation_email: e.boolean().default(!0).optional()
}), Bn = e.object({
	id: e.string(),
	organization_id: e.string().max(50),
	created_at: e.string().datetime(),
	expires_at: e.string().datetime(),
	ticket_id: e.string().optional()
}).extend(zn.omit({ id: !0 }).shape), Vn = e.object({
	alg: e.enum([
		"RS256",
		"RS384",
		"RS512",
		"ES256",
		"ES384",
		"ES512",
		"HS256",
		"HS384",
		"HS512"
	]).optional(),
	kid: e.string().optional(),
	kty: e.enum([
		"RSA",
		"EC",
		"oct"
	]),
	use: e.enum(["sig", "enc"]).optional(),
	n: e.string().optional(),
	e: e.string().optional(),
	crv: e.string().optional(),
	x: e.string().optional(),
	y: e.string().optional(),
	x5t: e.string().optional(),
	"x5t#S256": e.string().optional(),
	x5c: e.array(e.string()).optional()
}).superRefine((t, n) => {
	if (t.kty === "RSA") for (let r of ["n", "e"]) t[r] || n.addIssue({
		code: e.ZodIssueCode.custom,
		path: [r],
		message: `RSA JWK is missing required member '${r}'`
	});
	else if (t.kty === "EC") for (let r of [
		"crv",
		"x",
		"y"
	]) t[r] || n.addIssue({
		code: e.ZodIssueCode.custom,
		path: [r],
		message: `EC JWK is missing required member '${r}'`
	});
}), Hn = e.object({ keys: e.array(Vn) }), Un = e.object({
	issuer: e.string(),
	authorization_endpoint: e.string(),
	token_endpoint: e.string(),
	device_authorization_endpoint: e.string().optional(),
	userinfo_endpoint: e.string(),
	jwks_uri: e.string(),
	registration_endpoint: e.string().optional(),
	revocation_endpoint: e.string(),
	end_session_endpoint: e.string().optional(),
	scopes_supported: e.array(e.string()),
	response_types_supported: e.array(e.string()),
	grant_types_supported: e.array(e.string()).optional(),
	code_challenge_methods_supported: e.array(e.string()),
	response_modes_supported: e.array(e.string()),
	subject_types_supported: e.array(e.string()),
	id_token_signing_alg_values_supported: e.array(e.string()),
	token_endpoint_auth_methods_supported: e.array(e.string()),
	claims_supported: e.array(e.string()),
	request_uri_parameter_supported: e.boolean(),
	request_parameter_supported: e.boolean(),
	claims_parameter_supported: e.boolean().optional(),
	request_object_signing_alg_values_supported: e.array(e.string()).optional(),
	token_endpoint_auth_signing_alg_values_supported: e.array(e.string()),
	client_id_metadata_document_supported: e.boolean().optional(),
	backchannel_logout_supported: e.boolean().optional(),
	backchannel_logout_session_supported: e.boolean().optional()
}), Wn = /* @__PURE__ */ function(e) {
	return e.PENDING = "pending", e.AUTHENTICATED = "authenticated", e.AWAITING_EMAIL_VERIFICATION = "awaiting_email_verification", e.AWAITING_MFA = "awaiting_mfa", e.AWAITING_HOOK = "awaiting_hook", e.AWAITING_CONTINUATION = "awaiting_continuation", e.AWAITING_CONSENT = "awaiting_consent", e.COMPLETED = "completed", e.FAILED = "failed", e.EXPIRED = "expired", e;
}({}), Gn = e.nativeEnum(Wn), z = e.object({
	strategy: e.string(),
	strategy_type: e.string()
}), Kn = e.object({
	csrf_token: e.string(),
	auth0Client: e.string().optional(),
	authParams: ft,
	expires_at: e.string(),
	deleted_at: e.string().optional(),
	ip: e.string().optional(),
	useragent: e.string().optional(),
	session_id: e.string().optional(),
	authorization_url: e.string().optional(),
	state: Gn.optional().default("pending"),
	state_data: e.string().optional(),
	failure_reason: e.string().optional(),
	user_id: e.string().optional(),
	auth_connection: e.string().optional(),
	auth_strategy: z.optional(),
	authenticated_at: e.string().optional()
}).openapi({ description: "This represents a login sesion" }), qn = Kn.extend({
	id: e.string().openapi({ description: "This is is used as the state in the universal login" }),
	created_at: e.string(),
	updated_at: e.string()
}), B = {
	ACLS_SUMMARY: "acls_summary",
	ACTIONS_EXECUTION_FAILED: "actions_execution_failed",
	API_LIMIT: "api_limit",
	API_LIMIT_WARNING: "api_limit_warning",
	APPI: "appi",
	CIBA_EXCHANGE_FAILED: "ciba_exchange_failed",
	CIBA_EXCHANGE_SUCCEEDED: "ciba_exchange_succeeded",
	CIBA_START_FAILED: "ciba_start_failed",
	CIBA_START_SUCCEEDED: "ciba_start_succeeded",
	CODE_LINK_SENT: "cls",
	CODE_SENT: "cs",
	DEPRECATION_NOTICE: "depnote",
	CONFIG_INHERITANCE_DIFF: "cfgdiff",
	CONFIG_DRIFT: "cfgdrift",
	FAILED_LOGIN: "f",
	FAILED_BY_CONNECTOR: "fc",
	FAILED_CHANGE_EMAIL: "fce",
	FAILED_BY_CORS: "fco",
	FAILED_CROSS_ORIGIN_AUTHENTICATION: "fcoa",
	FAILED_CHANGE_PASSWORD: "fcp",
	FAILED_POST_CHANGE_PASSWORD_HOOK: "fcph",
	FAILED_CHANGE_PHONE_NUMBER: "fcpn",
	FAILED_CHANGE_PASSWORD_REQUEST: "fcpr",
	FAILED_CONNECTOR_PROVISIONING: "fcpro",
	FAILED_CHANGE_USERNAME: "fcu",
	FAILED_DELEGATION: "fd",
	FAILED_DEVICE_ACTIVATION: "fdeac",
	FAILED_DEVICE_AUTHORIZATION_REQUEST: "fdeaz",
	USER_CANCELED_DEVICE_CONFIRMATION: "fdecc",
	FAILED_USER_DELETION: "fdu",
	FAILED_EXCHANGE_AUTHORIZATION_CODE_FOR_ACCESS_TOKEN: "feacft",
	FAILED_EXCHANGE_ACCESS_TOKEN_FOR_CLIENT_CREDENTIALS: "feccft",
	FAILED_EXCHANGE_CUSTOM_TOKEN: "fecte",
	FAILED_EXCHANGE_DEVICE_CODE_FOR_ACCESS_TOKEN: "fede",
	FAILED_FEDERATED_LOGOUT: "federated_logout_failed",
	FAILED_EXCHANGE_NATIVE_SOCIAL_LOGIN: "fens",
	FAILED_EXCHANGE_PASSWORD_OOB_FOR_ACCESS_TOKEN: "feoobft",
	FAILED_EXCHANGE_PASSWORD_OTP_FOR_ACCESS_TOKEN: "feotpft",
	FAILED_EXCHANGE_PASSWORD_FOR_ACCESS_TOKEN: "fepft",
	FAILED_EXCHANGE_PASSWORDLESS_OTP_FOR_ACCESS_TOKEN: "fepotpft",
	FAILED_EXCHANGE_PASSWORD_MFA_RECOVERY_FOR_ACCESS_TOKEN: "fercft",
	FAILED_EXCHANGE_ROTATING_REFRESH_TOKEN: "ferrt",
	FAILED_EXCHANGE_REFRESH_TOKEN_FOR_ACCESS_TOKEN: "fertft",
	FAILED_EXCHANGE_SUBJECT_TOKEN_FOR_ACCESS_TOKEN: "festft",
	FAILED_HOOK: "fh",
	FAILED_IMPERSONATION: "fimp",
	FAILED_INVITE_ACCEPT: "fi",
	FAILED_LOGOUT: "flo",
	FLOWS_EXECUTION_COMPLETED: "flows_execution_completed",
	FLOWS_EXECUTION_FAILED: "flows_execution_failed",
	FAILED_SENDING_NOTIFICATION: "fn",
	FORMS_SUBMISSION_FAILED: "forms_submission_failed",
	FORMS_SUBMISSION_SUCCEEDED: "forms_submission_succeeded",
	FAILED_LOGIN_INCORRECT_PASSWORD: "fp",
	FAILED_PUSHED_AUTHORIZATION_REQUEST: "fpar",
	FAILED_POST_USER_REGISTRATION_HOOK: "fpurh",
	FAILED_SIGNUP: "fs",
	FAILED_SILENT_AUTH: "fsa",
	FAILED_LOGIN_INVALID_EMAIL_USERNAME: "fu",
	FAILED_USERS_IMPORT: "fui",
	FAILED_VERIFICATION_EMAIL: "fv",
	FAILED_VERIFICATION_EMAIL_REQUEST: "fvr",
	EMAIL_VERIFICATION_CONFIRMED: "gd_auth_email_verification",
	EMAIL_VERIFICATION_FAILED: "gd_auth_fail_email_verification",
	MFA_AUTH_FAILED: "gd_auth_failed",
	MFA_AUTH_REJECTED: "gd_auth_rejected",
	MFA_AUTH_SUCCESS: "gd_auth_succeed",
	MFA_ENROLLMENT_COMPLETE: "gd_enrollment_complete",
	TOO_MANY_MFA_FAILURES: "gd_otp_rate_limit_exceed",
	MFA_RECOVERY_FAILED: "gd_recovery_failed",
	MFA_RECOVERY_RATE_LIMIT_EXCEED: "gd_recovery_rate_limit_exceed",
	MFA_RECOVERY_SUCCESS: "gd_recovery_succeed",
	MFA_EMAIL_SENT: "gd_send_email",
	EMAIL_VERIFICATION_SENT: "gd_send_email_verification",
	EMAIL_VERIFICATION_SEND_FAILURE: "gd_send_email_verification_failure",
	PUSH_NOTIFICATION_SENT: "gd_send_pn",
	ERROR_SENDING_MFA_PUSH_NOTIFICATION: "gd_send_pn_failure",
	MFA_SMS_SENT: "gd_send_sms",
	ERROR_SENDING_MFA_SMS: "gd_send_sms_failure",
	MFA_VOICE_CALL_SUCCESS: "gd_send_voice",
	MFA_VOICE_CALL_FAILED: "gd_send_voice_failure",
	SECOND_FACTOR_STARTED: "gd_start_auth",
	MFA_ENROLL_STARTED: "gd_start_enroll",
	MFA_ENROLLMENT_FAILED: "gd_start_enroll_failed",
	GUARDIAN_TENANT_UPDATE: "gd_tenant_update",
	UNENROLL_DEVICE_ACCOUNT: "gd_unenroll",
	UPDATE_DEVICE_ACCOUNT: "gd_update_device_account",
	WEBAUTHN_CHALLENGE_FAILED: "gd_webauthn_challenge_failed",
	WEBAUTHN_ENROLLMENT_FAILED: "gd_webauthn_enrollment_failed",
	FAILED_KMS_API_OPERATION: "kms_key_management_failure",
	SUCCESS_KMS_API_OPERATION: "kms_key_management_success",
	KMS_KEY_STATE_CHANGED: "kms_key_state_changed",
	TOO_MANY_CALLS_TO_DELEGATION: "limit_delegation",
	BLOCKED_IP_ADDRESS: "limit_mu",
	BLOCKED_ACCOUNT_IP: "limit_sul",
	BLOCKED_ACCOUNT_EMAIL: "limit_wc",
	INFORMATION: "i",
	MFA_REQUIRED: "mfar",
	MANAGEMENT_API_READ_OPERATION: "mgmt_api_read",
	FAILED_AUTHENTICATION_METHOD_OPERATION_MY_ACCOUNT: "my_account_authentication_method_failed",
	SUCCESSFUL_AUTHENTICATION_METHOD_OPERATION_MY_ACCOUNT: "my_account_authentication_method_succeeded",
	FAILED_OIDC_BACKCHANNEL_LOGOUT: "oidc_backchannel_logout_failed",
	SUCCESSFUL_OIDC_BACKCHANNEL_LOGOUT: "oidc_backchannel_logout_succeeded",
	ORGANIZATION_MEMBER_ADDED: "organization_member_added",
	PASSKEY_CHALLENGE_FAILED: "passkey_challenge_failed",
	PASSKEY_CHALLENGE_STARTED: "passkey_challenge_started",
	PRE_LOGIN_ASSESSMENT: "pla",
	BREACHED_PASSWORD: "pwd_leak",
	BREACHED_PASSWORD_ON_RESET: "reset_pwd_leak",
	SUCCESS_RESOURCE_CLEANUP: "resource_cleanup",
	RICH_CONSENTS_ACCESS_ERROR: "rich_consents_access_error",
	SUCCESS_LOGIN: "s",
	SUCCESS_API_OPERATION: "sapi",
	FAILED_API_OPERATION: "fapi",
	SUCCESS_CHANGE_EMAIL: "sce",
	SUCCESS_CROSS_ORIGIN_AUTHENTICATION: "scoa",
	SUCCESS_CHANGE_PASSWORD: "scp",
	SUCCESS_CHANGE_PHONE_NUMBER: "scpn",
	SUCCESS_CHANGE_PASSWORD_REQUEST: "scpr",
	SUCCESS_CHANGE_USERNAME: "scu",
	SUCCESS_CREDENTIAL_VALIDATION: "scv",
	SUCCESS_DELEGATION: "sd",
	SUCCESS_USER_DELETION: "sdu",
	SUCCESS_EXCHANGE_AUTHORIZATION_CODE_FOR_ACCESS_TOKEN: "seacft",
	SUCCESS_EXCHANGE_ACCESS_TOKEN_FOR_CLIENT_CREDENTIALS: "seccft",
	SUCCESS_EXCHANGE_CUSTOM_TOKEN: "secte",
	SUCCESS_EXCHANGE_DEVICE_CODE_FOR_ACCESS_TOKEN: "sede",
	SUCCESS_EXCHANGE_NATIVE_SOCIAL_LOGIN: "sens",
	SUCCESS_EXCHANGE_PASSWORD_OOB_FOR_ACCESS_TOKEN: "seoobft",
	SUCCESS_EXCHANGE_PASSWORD_OTP_FOR_ACCESS_TOKEN: "seotpft",
	SUCCESS_EXCHANGE_PASSWORDLESS_OTP_FOR_ACCESS_TOKEN: "sepotpft",
	SUCCESS_EXCHANGE_PASSWORD_FOR_ACCESS_TOKEN: "sepft",
	SUCCESS_EXCHANGE_PASSKEY_OOB_FOR_ACCESS_TOKEN: "sepkoobft",
	SUCCESS_EXCHANGE_PASSKEY_OTP_FOR_ACCESS_TOKEN: "sepkotpft",
	SUCCESS_EXCHANGE_PASSKEY_MFA_RECOVERY_FOR_ACCESS_TOKEN: "sepkrcft",
	SUCCESS_EXCHANGE_PASSWORD_MFA_RECOVERY_FOR_ACCESS_TOKEN: "sercft",
	SUCCESS_EXCHANGE_REFRESH_TOKEN_FOR_ACCESS_TOKEN: "sertft",
	SUCCESS_EXCHANGE_SUBJECT_TOKEN_FOR_ACCESS_TOKEN: "sestft",
	SUCCESS_IMPERSONATION: "simp",
	SUCCESSFULLY_ACCEPTED_USER_INVITE: "si",
	BREACHED_PASSWORD_ON_SIGNUP: "signup_pwd_leak",
	SUCCESS_LOGOUT: "slo",
	SUCCESS_HOOK: "sh",
	SUCCESS_PASSWORD_MIGRATION: "spm",
	SUCCESS_REVOCATION: "srrt",
	SUCCESS_SIGNUP: "ss",
	FAILED_SS_SSO_OPERATION: "ss_sso_failure",
	INFORMATION_FROM_SS_SSO_OPERATION: "ss_sso_info",
	SUCCESS_SS_SSO_OPERATION: "ss_sso_success",
	SUCCESS_SILENT_AUTH: "ssa",
	SUCCESSFUL_SCIM_OPERATION: "sscim",
	SUCCESSFULLY_IMPORTED_USERS: "sui",
	SUCCESS_VERIFICATION_EMAIL: "sv",
	SUCCESS_VERIFICATION_EMAIL_REQUEST: "svr",
	MAX_AMOUNT_OF_AUTHENTICATORS: "too_many_records",
	USER_LOGIN_BLOCK_RELEASED: "ublkdu",
	FAILED_UNIVERSAL_LOGOUT: "universal_logout_failed",
	SUCCESSFUL_UNIVERSAL_LOGOUT: "universal_logout_succeeded",
	WARNING_DURING_LOGIN: "w",
	WARNING_SENDING_NOTIFICATION: "wn",
	WARNING_USER_MANAGEMENT: "wum"
}, Jn = e.string().refine((e) => Object.values(B).includes(e), { message: "Invalid log type" }), Yn = {
	[B.ACLS_SUMMARY]: "ACLs Summary",
	[B.ACTIONS_EXECUTION_FAILED]: "Actions Execution Failed",
	[B.API_LIMIT]: "API Rate Limit Reached",
	[B.API_LIMIT_WARNING]: "API Rate Limit Warning",
	[B.APPI]: "API Operation",
	[B.CIBA_EXCHANGE_FAILED]: "CIBA Exchange Failed",
	[B.CIBA_EXCHANGE_SUCCEEDED]: "CIBA Exchange Succeeded",
	[B.CIBA_START_FAILED]: "CIBA Start Failed",
	[B.CIBA_START_SUCCEEDED]: "CIBA Start Succeeded",
	[B.CODE_LINK_SENT]: "Code/Link Sent",
	[B.CODE_SENT]: "Code Sent",
	[B.DEPRECATION_NOTICE]: "Deprecation Notice",
	[B.CONFIG_INHERITANCE_DIFF]: "Config Inheritance Shadow Difference",
	[B.CONFIG_DRIFT]: "Config Drift",
	[B.FAILED_LOGIN]: "Failed Login",
	[B.FAILED_BY_CONNECTOR]: "Failed by Connector",
	[B.FAILED_CHANGE_EMAIL]: "Failed Change Email",
	[B.FAILED_BY_CORS]: "Failed by CORS",
	[B.FAILED_CROSS_ORIGIN_AUTHENTICATION]: "Failed Cross Origin Authentication",
	[B.FAILED_CHANGE_PASSWORD]: "Failed Change Password",
	[B.FAILED_POST_CHANGE_PASSWORD_HOOK]: "Failed Post-Change Password Hook",
	[B.FAILED_CHANGE_PHONE_NUMBER]: "Failed Change Phone Number",
	[B.FAILED_CHANGE_PASSWORD_REQUEST]: "Failed Change Password Request",
	[B.FAILED_CONNECTOR_PROVISIONING]: "Failed Connector Provisioning",
	[B.FAILED_CHANGE_USERNAME]: "Failed Change Username",
	[B.FAILED_DELEGATION]: "Failed Delegation",
	[B.FAILED_DEVICE_ACTIVATION]: "Failed Device Activation",
	[B.FAILED_DEVICE_AUTHORIZATION_REQUEST]: "Failed Device Authorization Request",
	[B.USER_CANCELED_DEVICE_CONFIRMATION]: "User Canceled Device Confirmation",
	[B.FAILED_USER_DELETION]: "Failed User Deletion",
	[B.FAILED_EXCHANGE_AUTHORIZATION_CODE_FOR_ACCESS_TOKEN]: "Failed Exchange Authorization Code for Access Token",
	[B.FAILED_EXCHANGE_ACCESS_TOKEN_FOR_CLIENT_CREDENTIALS]: "Failed Exchange Access Token for Client Credentials",
	[B.FAILED_EXCHANGE_CUSTOM_TOKEN]: "Failed Exchange Custom Token",
	[B.FAILED_EXCHANGE_DEVICE_CODE_FOR_ACCESS_TOKEN]: "Failed Exchange Device Code for Access Token",
	[B.FAILED_FEDERATED_LOGOUT]: "Failed Federated Logout",
	[B.FAILED_EXCHANGE_NATIVE_SOCIAL_LOGIN]: "Failed Exchange Native Social Login",
	[B.FAILED_EXCHANGE_PASSWORD_OOB_FOR_ACCESS_TOKEN]: "Failed Exchange Password OOB for Access Token",
	[B.FAILED_EXCHANGE_PASSWORD_OTP_FOR_ACCESS_TOKEN]: "Failed Exchange Password OTP for Access Token",
	[B.FAILED_EXCHANGE_PASSWORD_FOR_ACCESS_TOKEN]: "Failed Exchange Password for Access Token",
	[B.FAILED_EXCHANGE_PASSWORDLESS_OTP_FOR_ACCESS_TOKEN]: "Failed Exchange Passwordless OTP for Access Token",
	[B.FAILED_EXCHANGE_PASSWORD_MFA_RECOVERY_FOR_ACCESS_TOKEN]: "Failed Exchange Password MFA Recovery for Access Token",
	[B.FAILED_EXCHANGE_ROTATING_REFRESH_TOKEN]: "Failed Exchange Rotating Refresh Token",
	[B.FAILED_EXCHANGE_REFRESH_TOKEN_FOR_ACCESS_TOKEN]: "Failed Exchange Refresh Token for Access Token",
	[B.FAILED_EXCHANGE_SUBJECT_TOKEN_FOR_ACCESS_TOKEN]: "Failed Exchange Subject Token for Access Token",
	[B.FAILED_HOOK]: "Failed Hook",
	[B.FAILED_IMPERSONATION]: "Failed Impersonation",
	[B.FAILED_INVITE_ACCEPT]: "Failed Invite Accept",
	[B.FAILED_LOGOUT]: "Failed Logout",
	[B.FLOWS_EXECUTION_COMPLETED]: "Flows Execution Completed",
	[B.FLOWS_EXECUTION_FAILED]: "Flows Execution Failed",
	[B.FAILED_SENDING_NOTIFICATION]: "Failed Sending Notification",
	[B.FORMS_SUBMISSION_FAILED]: "Forms Submission Failed",
	[B.FORMS_SUBMISSION_SUCCEEDED]: "Forms Submission Succeeded",
	[B.FAILED_LOGIN_INCORRECT_PASSWORD]: "Failed Login - Incorrect Password",
	[B.FAILED_PUSHED_AUTHORIZATION_REQUEST]: "Failed Pushed Authorization Request",
	[B.FAILED_POST_USER_REGISTRATION_HOOK]: "Failed Post-User Registration Hook",
	[B.FAILED_SIGNUP]: "Failed Signup",
	[B.FAILED_SILENT_AUTH]: "Failed Silent Auth",
	[B.FAILED_LOGIN_INVALID_EMAIL_USERNAME]: "Failed Login - Invalid Email/Username",
	[B.FAILED_USERS_IMPORT]: "Failed Users Import",
	[B.FAILED_VERIFICATION_EMAIL]: "Failed Verification Email",
	[B.FAILED_VERIFICATION_EMAIL_REQUEST]: "Failed Verification Email Request",
	[B.EMAIL_VERIFICATION_CONFIRMED]: "Email Verification Confirmed",
	[B.EMAIL_VERIFICATION_FAILED]: "Email Verification Failed",
	[B.MFA_AUTH_FAILED]: "MFA Auth Failed",
	[B.MFA_AUTH_REJECTED]: "MFA Auth Rejected",
	[B.MFA_AUTH_SUCCESS]: "MFA Auth Success",
	[B.MFA_ENROLLMENT_COMPLETE]: "MFA Enrollment Complete",
	[B.TOO_MANY_MFA_FAILURES]: "Too Many MFA Failures",
	[B.MFA_RECOVERY_FAILED]: "MFA Recovery Failed",
	[B.MFA_RECOVERY_RATE_LIMIT_EXCEED]: "MFA Recovery Rate Limit Exceeded",
	[B.MFA_RECOVERY_SUCCESS]: "MFA Recovery Success",
	[B.MFA_EMAIL_SENT]: "MFA Email Sent",
	[B.EMAIL_VERIFICATION_SENT]: "Email Verification Sent",
	[B.EMAIL_VERIFICATION_SEND_FAILURE]: "Email Verification Send Failure",
	[B.PUSH_NOTIFICATION_SENT]: "Push Notification Sent",
	[B.ERROR_SENDING_MFA_PUSH_NOTIFICATION]: "Error Sending MFA Push Notification",
	[B.MFA_SMS_SENT]: "MFA SMS Sent",
	[B.ERROR_SENDING_MFA_SMS]: "Error Sending MFA SMS",
	[B.MFA_VOICE_CALL_SUCCESS]: "MFA Voice Call Success",
	[B.MFA_VOICE_CALL_FAILED]: "MFA Voice Call Failed",
	[B.SECOND_FACTOR_STARTED]: "Second Factor Started",
	[B.MFA_ENROLL_STARTED]: "MFA Enroll Started",
	[B.MFA_ENROLLMENT_FAILED]: "MFA Enrollment Failed",
	[B.GUARDIAN_TENANT_UPDATE]: "Guardian Tenant Update",
	[B.UNENROLL_DEVICE_ACCOUNT]: "Unenroll Device Account",
	[B.UPDATE_DEVICE_ACCOUNT]: "Update Device Account",
	[B.WEBAUTHN_CHALLENGE_FAILED]: "WebAuthn Challenge Failed",
	[B.WEBAUTHN_ENROLLMENT_FAILED]: "WebAuthn Enrollment Failed",
	[B.FAILED_KMS_API_OPERATION]: "Failed KMS API Operation",
	[B.SUCCESS_KMS_API_OPERATION]: "Success KMS API Operation",
	[B.KMS_KEY_STATE_CHANGED]: "KMS Key State Changed",
	[B.TOO_MANY_CALLS_TO_DELEGATION]: "Too Many Calls to Delegation",
	[B.BLOCKED_IP_ADDRESS]: "Blocked IP Address",
	[B.BLOCKED_ACCOUNT_IP]: "Blocked Account (IP)",
	[B.BLOCKED_ACCOUNT_EMAIL]: "Blocked Account (Email)",
	[B.INFORMATION]: "Information",
	[B.MFA_REQUIRED]: "MFA Required",
	[B.MANAGEMENT_API_READ_OPERATION]: "Management API Read Operation",
	[B.FAILED_AUTHENTICATION_METHOD_OPERATION_MY_ACCOUNT]: "Failed Authentication Method Operation (My Account)",
	[B.SUCCESSFUL_AUTHENTICATION_METHOD_OPERATION_MY_ACCOUNT]: "Successful Authentication Method Operation (My Account)",
	[B.FAILED_OIDC_BACKCHANNEL_LOGOUT]: "Failed OIDC Backchannel Logout",
	[B.SUCCESSFUL_OIDC_BACKCHANNEL_LOGOUT]: "Successful OIDC Backchannel Logout",
	[B.ORGANIZATION_MEMBER_ADDED]: "Organization Member Added",
	[B.PASSKEY_CHALLENGE_FAILED]: "Passkey Challenge Failed",
	[B.PASSKEY_CHALLENGE_STARTED]: "Passkey Challenge Started",
	[B.PRE_LOGIN_ASSESSMENT]: "Pre-Login Assessment",
	[B.BREACHED_PASSWORD]: "Breached Password",
	[B.BREACHED_PASSWORD_ON_RESET]: "Breached Password on Reset",
	[B.SUCCESS_RESOURCE_CLEANUP]: "Success Resource Cleanup",
	[B.RICH_CONSENTS_ACCESS_ERROR]: "Rich Consents Access Error",
	[B.SUCCESS_LOGIN]: "Success Login",
	[B.SUCCESS_API_OPERATION]: "Success API Operation",
	[B.FAILED_API_OPERATION]: "Failed API Operation",
	[B.SUCCESS_CHANGE_EMAIL]: "Success Change Email",
	[B.SUCCESS_CROSS_ORIGIN_AUTHENTICATION]: "Success Cross Origin Authentication",
	[B.SUCCESS_CHANGE_PASSWORD]: "Success Change Password",
	[B.SUCCESS_CHANGE_PHONE_NUMBER]: "Success Change Phone Number",
	[B.SUCCESS_CHANGE_PASSWORD_REQUEST]: "Success Change Password Request",
	[B.SUCCESS_CHANGE_USERNAME]: "Success Change Username",
	[B.SUCCESS_CREDENTIAL_VALIDATION]: "Success Credential Validation",
	[B.SUCCESS_DELEGATION]: "Success Delegation",
	[B.SUCCESS_USER_DELETION]: "Success User Deletion",
	[B.SUCCESS_EXCHANGE_AUTHORIZATION_CODE_FOR_ACCESS_TOKEN]: "Success Exchange Authorization Code for Access Token",
	[B.SUCCESS_EXCHANGE_ACCESS_TOKEN_FOR_CLIENT_CREDENTIALS]: "Success Exchange Access Token for Client Credentials",
	[B.SUCCESS_EXCHANGE_CUSTOM_TOKEN]: "Success Exchange Custom Token",
	[B.SUCCESS_EXCHANGE_DEVICE_CODE_FOR_ACCESS_TOKEN]: "Success Exchange Device Code for Access Token",
	[B.SUCCESS_EXCHANGE_NATIVE_SOCIAL_LOGIN]: "Success Exchange Native Social Login",
	[B.SUCCESS_EXCHANGE_PASSWORD_OOB_FOR_ACCESS_TOKEN]: "Success Exchange Password OOB for Access Token",
	[B.SUCCESS_EXCHANGE_PASSWORD_OTP_FOR_ACCESS_TOKEN]: "Success Exchange Password OTP for Access Token",
	[B.SUCCESS_EXCHANGE_PASSWORDLESS_OTP_FOR_ACCESS_TOKEN]: "Success Exchange Passwordless OTP for Access Token",
	[B.SUCCESS_EXCHANGE_PASSWORD_FOR_ACCESS_TOKEN]: "Success Exchange Password for Access Token",
	[B.SUCCESS_EXCHANGE_PASSKEY_OOB_FOR_ACCESS_TOKEN]: "Success Exchange Passkey OOB for Access Token",
	[B.SUCCESS_EXCHANGE_PASSKEY_OTP_FOR_ACCESS_TOKEN]: "Success Exchange Passkey OTP for Access Token",
	[B.SUCCESS_EXCHANGE_PASSKEY_MFA_RECOVERY_FOR_ACCESS_TOKEN]: "Success Exchange Passkey MFA Recovery for Access Token",
	[B.SUCCESS_EXCHANGE_PASSWORD_MFA_RECOVERY_FOR_ACCESS_TOKEN]: "Success Exchange Password MFA Recovery for Access Token",
	[B.SUCCESS_EXCHANGE_REFRESH_TOKEN_FOR_ACCESS_TOKEN]: "Success Exchange Refresh Token for Access Token",
	[B.SUCCESS_EXCHANGE_SUBJECT_TOKEN_FOR_ACCESS_TOKEN]: "Success Exchange Subject Token for Access Token",
	[B.SUCCESS_IMPERSONATION]: "Success Impersonation",
	[B.SUCCESSFULLY_ACCEPTED_USER_INVITE]: "Successfully Accepted User Invite",
	[B.BREACHED_PASSWORD_ON_SIGNUP]: "Breached Password on Signup",
	[B.SUCCESS_LOGOUT]: "Success Logout",
	[B.SUCCESS_HOOK]: "Success Hook",
	[B.SUCCESS_PASSWORD_MIGRATION]: "Success Password Migration",
	[B.SUCCESS_REVOCATION]: "Success Revocation",
	[B.SUCCESS_SIGNUP]: "Success Signup",
	[B.FAILED_SS_SSO_OPERATION]: "Failed SS SSO Operation",
	[B.INFORMATION_FROM_SS_SSO_OPERATION]: "Information from SS SSO Operation",
	[B.SUCCESS_SS_SSO_OPERATION]: "Success SS SSO Operation",
	[B.SUCCESS_SILENT_AUTH]: "Success Silent Auth",
	[B.SUCCESSFUL_SCIM_OPERATION]: "Successful SCIM Operation",
	[B.SUCCESSFULLY_IMPORTED_USERS]: "Successfully Imported Users",
	[B.SUCCESS_VERIFICATION_EMAIL]: "Success Verification Email",
	[B.SUCCESS_VERIFICATION_EMAIL_REQUEST]: "Success Verification Email Request",
	[B.MAX_AMOUNT_OF_AUTHENTICATORS]: "Max Amount of Authenticators",
	[B.USER_LOGIN_BLOCK_RELEASED]: "User Login Block Released",
	[B.FAILED_UNIVERSAL_LOGOUT]: "Failed Universal Logout",
	[B.SUCCESSFUL_UNIVERSAL_LOGOUT]: "Successful Universal Logout",
	[B.WARNING_DURING_LOGIN]: "Warning During Login",
	[B.WARNING_SENDING_NOTIFICATION]: "Warning Sending Notification",
	[B.WARNING_USER_MANAGEMENT]: "Warning User Management"
}, Xn = (() => {
	let e = {};
	for (let [t, n] of Object.entries(B)) t.startsWith("SUCCESS_") || t.startsWith("SUCCESSFUL_") || t.startsWith("SUCCESSFULLY_") || t.endsWith("_SUCCEEDED") || t.endsWith("_COMPLETED") ? e[n] = "success" : t.startsWith("FAILED_") || t.startsWith("ERROR_") || t.startsWith("BREACHED_") || t.startsWith("BLOCKED_") || t === "MFA_AUTH_FAILED" || t === "MFA_AUTH_REJECTED" || t === "MFA_RECOVERY_FAILED" || t === "MFA_ENROLLMENT_FAILED" || t === "EMAIL_VERIFICATION_FAILED" || t === "WEBAUTHN_CHALLENGE_FAILED" || t === "WEBAUTHN_ENROLLMENT_FAILED" || t === "PASSKEY_CHALLENGE_FAILED" || t === "FLOWS_EXECUTION_FAILED" || t === "FORMS_SUBMISSION_FAILED" || t === "CIBA_EXCHANGE_FAILED" || t === "CIBA_START_FAILED" || t === "ACTIONS_EXECUTION_FAILED" || t === "RICH_CONSENTS_ACCESS_ERROR" || t === "USER_CANCELED_DEVICE_CONFIRMATION" || t === "TOO_MANY_MFA_FAILURES" || t === "MFA_RECOVERY_RATE_LIMIT_EXCEED" || t === "API_LIMIT" || t === "MAX_AMOUNT_OF_AUTHENTICATORS" ? e[n] = "failure" : t.startsWith("WARNING_") || t === "API_LIMIT_WARNING" || t === "DEPRECATION_NOTICE" || t === "PRE_LOGIN_ASSESSMENT" ? e[n] = "warning" : t === "CODE_SENT" || t === "CODE_LINK_SENT" || t === "MFA_EMAIL_SENT" || t === "MFA_SMS_SENT" || t === "EMAIL_VERIFICATION_SENT" || t === "PUSH_NOTIFICATION_SENT" ? e[n] = "code_sent" : t === "INFORMATION" || t === "INFORMATION_FROM_SS_SSO_OPERATION" || t === "MANAGEMENT_API_READ_OPERATION" || t === "APPI" || t === "CONFIG_INHERITANCE_DIFF" || t === "CONFIG_DRIFT" || t === "ACLS_SUMMARY" || t === "ORGANIZATION_MEMBER_ADDED" ? e[n] = "info" : e[n] = "other";
	return e;
})();
function Zn(e) {
	return Yn[e] ?? e;
}
function Qn(e) {
	return Xn[e] ?? "other";
}
var $n = e.object({
	name: e.string(),
	version: e.string(),
	env: e.object({ node: e.string().optional() }).optional()
}), er = e.object({
	country_code: e.string().length(2),
	city_name: e.string(),
	latitude: e.string(),
	longitude: e.string(),
	time_zone: e.string(),
	continent_code: e.string()
}), tr = e.object({
	type: Jn,
	date: e.string(),
	description: e.string().optional(),
	ip: e.string().optional(),
	user_agent: e.string().optional(),
	details: e.any().optional(),
	isMobile: e.boolean(),
	user_id: e.string().optional(),
	user_name: e.string().optional(),
	connection: e.string().optional(),
	connection_id: e.string().optional(),
	client_id: e.string().optional(),
	client_name: e.string().optional(),
	audience: e.string().optional(),
	scope: e.string().optional(),
	strategy: e.string().optional(),
	strategy_type: e.string().optional(),
	hostname: e.string().optional(),
	auth0_client: $n.optional(),
	log_id: e.string().optional(),
	location_info: er.optional()
}), nr = tr.extend({ log_id: e.string() }), rr = e.enum([
	"http",
	"eventbridge",
	"eventgrid",
	"splunk",
	"datadog",
	"sumo"
]), V = e.enum([
	"active",
	"paused",
	"suspended"
]), ir = e.object({
	type: e.string(),
	name: e.string()
}), ar = e.object({
	name: e.string(),
	type: rr,
	status: V.optional(),
	sink: e.record(e.string(), e.unknown()),
	filters: e.array(ir).optional(),
	isPriority: e.boolean().optional()
}), or = ar.extend({
	id: e.string(),
	status: V,
	created_at: e.string().optional(),
	updated_at: e.string().optional()
}), sr = e.enum([
	"auth0",
	"cognito",
	"okta",
	"oidc"
]), cr = e.object({
	domain: e.string(),
	client_id: e.string(),
	client_secret: e.string(),
	audience: e.string().optional(),
	scope: e.string().optional()
}), lr = e.object({
	id: e.string().optional(),
	name: e.string(),
	provider: sr,
	connection: e.string(),
	enabled: e.boolean().default(!0),
	credentials: cr
}), ur = e.object({
	id: e.string(),
	created_at: e.string(),
	updated_at: e.string()
}).extend(lr.shape), dr = e.object({
	enabled: e.boolean().optional(),
	shields: e.array(e.string()).optional(),
	admin_notification_frequency: e.array(e.string()).optional(),
	method: e.string().optional(),
	stage: e.object({
		"pre-user-registration": e.object({ shields: e.array(e.string()).optional() }).optional(),
		"pre-change-password": e.object({ shields: e.array(e.string()).optional() }).optional()
	}).optional()
}), fr = e.object({
	enabled: e.boolean().optional(),
	shields: e.array(e.string()).optional(),
	allowlist: e.array(e.string()).optional(),
	mode: e.string().optional(),
	max_attempts: e.number().optional()
}), pr = e.object({
	enabled: e.boolean().optional(),
	shields: e.array(e.string()).optional(),
	allowlist: e.array(e.string()).optional(),
	stage: e.object({
		"pre-login": e.object({
			max_attempts: e.number().optional(),
			rate: e.number().optional()
		}).optional(),
		"pre-user-registration": e.object({
			max_attempts: e.number().optional(),
			rate: e.number().optional()
		}).optional()
	}).optional()
}), mr = e.object({
	breached_password_detection: dr.optional(),
	brute_force_protection: fr.optional(),
	suspicious_ip_throttling: pr.optional()
}), hr = e.object({
	id: e.string().optional(),
	user_id: e.string(),
	password: e.string(),
	algorithm: e.enum(["bcrypt", "argon2id"]).default("argon2id"),
	is_current: e.boolean().default(!0)
}), gr = hr.extend({
	id: e.string(),
	created_at: e.string(),
	updated_at: e.string()
}), H = e.object({
	initial_user_agent: e.string().describe("First user agent of the device from which this user logged in"),
	initial_ip: e.string().describe("First IP address associated with this session"),
	initial_asn: e.string().describe("First autonomous system number associated with this session"),
	last_user_agent: e.string().describe("Last user agent of the device from which this user logged in"),
	last_ip: e.string().describe("Last IP address from which this user logged in"),
	last_asn: e.string().describe("Last autonomous system number from which this user logged in")
}), _r = e.object({
	id: e.string(),
	revoked_at: e.string().optional(),
	used_at: e.string().optional(),
	user_id: e.string().describe("The user ID associated with the session"),
	expires_at: e.string().optional(),
	login_session_id: e.string(),
	idle_expires_at: e.string().optional(),
	device: H.describe("Metadata related to the device used in the session"),
	clients: e.array(e.string()).describe("List of client details for the session")
}), vr = e.object({
	created_at: e.string(),
	updated_at: e.string(),
	authenticated_at: e.string(),
	last_interaction_at: e.string()
}).extend(_r.shape), yr = e.object({
	kid: e.string().openapi({ description: "The key id of the signing key" }),
	tenant_id: e.string().optional().openapi({ description: "The tenant the key belongs to. Omitted means the key is shared / control-plane scoped." }),
	cert: e.string().openapi({ description: "The public certificate of the signing key" }),
	fingerprint: e.string().openapi({ description: "The cert fingerprint" }),
	thumbprint: e.string().openapi({ description: "The cert thumbprint" }),
	pkcs7: e.string().optional().openapi({ description: "The private key in pkcs7 format" }),
	current: e.boolean().optional().openapi({ description: "True if the key is the current key" }),
	next: e.boolean().optional().openapi({ description: "True if the key is the next key" }),
	previous: e.boolean().optional().openapi({ description: "True if the key is the previous key" }),
	current_since: e.string().optional().openapi({ description: "The date and time when the key became the current key" }),
	current_until: e.string().optional().openapi({ description: "The date and time when the current key was rotated" }),
	revoked: e.boolean().optional().openapi({ description: "True if the key is revoked" }),
	revoked_at: e.string().optional().openapi({ description: "The date and time when the key was revoked" }),
	connection: e.string().optional().openapi({ description: "The connection identifier associated with the key" }),
	type: e.enum(["jwt_signing", "saml_encryption"]).openapi({ description: "The type of the signing key" })
}), br = e.object({
	id: e.string().optional(),
	parent_tenant_id: e.string().nullish(),
	config_sync: e.enum([
		"inherit-on-read",
		"synced",
		"detached"
	]).nullish(),
	config_sync_hash: e.string().nullish(),
	config_synced_at: e.string().nullish(),
	audience: e.string().optional(),
	friendly_name: e.string(),
	picture_url: e.string().optional(),
	support_email: e.string().optional(),
	support_url: e.string().optional(),
	sender_email: e.string().email().optional(),
	sender_name: e.string().optional(),
	session_lifetime: e.number().optional(),
	idle_session_lifetime: e.number().optional(),
	ephemeral_session_lifetime: e.number().optional(),
	idle_ephemeral_session_lifetime: e.number().optional(),
	session_cookie: e.object({ mode: e.enum(["persistent", "non-persistent"]).optional() }).optional(),
	allowed_logout_urls: e.array(e.string()).optional(),
	default_redirection_uri: e.string().optional(),
	default_client_id: e.string().optional(),
	enabled_locales: e.array(e.string()).optional(),
	default_directory: e.string().optional(),
	error_page: e.object({
		html: e.string().optional(),
		show_log_link: e.boolean().optional(),
		url: e.string().optional()
	}).nullish(),
	flags: e.object({
		allow_changing_enable_sso: e.boolean().optional(),
		allow_legacy_delegation_grant_types: e.boolean().optional(),
		allow_legacy_ro_grant_types: e.boolean().optional(),
		allow_legacy_tokeninfo_endpoint: e.boolean().optional(),
		change_pwd_flow_v1: e.boolean().optional(),
		client_id_metadata_document_registration: e.boolean().optional(),
		custom_domains_provisioning: e.boolean().optional(),
		dashboard_insights_view: e.boolean().optional(),
		dashboard_log_streams_next: e.boolean().optional(),
		disable_clickjack_protection_headers: e.boolean().optional(),
		disable_fields_map_fix: e.boolean().optional(),
		disable_impersonation: e.boolean().optional(),
		disable_management_api_sms_obfuscation: e.boolean().optional(),
		enable_adfs_waad_email_verification: e.boolean().optional(),
		enable_apis_section: e.boolean().optional(),
		enable_client_connections: e.boolean().optional(),
		enable_custom_domain_in_emails: e.boolean().optional(),
		enable_dynamic_client_registration: e.boolean().optional(),
		dcr_require_initial_access_token: e.boolean().optional(),
		dcr_allowed_grant_types: e.array(e.string()).optional(),
		allow_http_return_to: e.array(e.string().refine((e) => {
			try {
				let t = new URL(e);
				return t.protocol === "http:" && (t.pathname === "" || t.pathname === "/") && !t.search && !t.hash && e === t.origin;
			} catch {
				return !1;
			}
		}, { message: "must be a fully-qualified http origin (scheme + host + port, no path)" })).optional(),
		enable_idtoken_api2: e.boolean().optional(),
		enable_legacy_logs_search_v2: e.boolean().optional(),
		enable_legacy_profile: e.boolean().optional(),
		enable_pipeline2: e.boolean().optional(),
		enable_public_signup_user_exists_error: e.boolean().optional(),
		enable_sso: e.boolean().optional(),
		enforce_client_authentication_on_passwordless_start: e.boolean().optional(),
		genai_trial: e.boolean().optional(),
		improved_signup_bot_detection_in_classic: e.boolean().optional(),
		mfa_show_factor_list_on_enrollment: e.boolean().optional(),
		no_disclose_enterprise_connections: e.boolean().optional(),
		remove_alg_from_jwks: e.boolean().optional(),
		revoke_refresh_token_grant: e.boolean().optional(),
		trust_azure_adfs_email_verified_connection_property: e.boolean().optional(),
		use_scope_descriptions_for_consent: e.boolean().optional(),
		inherit_global_permissions_in_organizations: e.boolean().optional(),
		restrict_undefined_scopes: e.boolean().optional()
	}).optional(),
	sandbox_version: e.string().optional(),
	legacy_sandbox_version: e.string().optional(),
	sandbox_versions_available: e.array(e.string()).optional(),
	change_password: e.object({
		enabled: e.boolean().optional(),
		html: e.string().optional()
	}).optional(),
	guardian_mfa_page: e.object({
		enabled: e.boolean().optional(),
		html: e.string().optional()
	}).optional(),
	device_flow: e.object({
		charset: e.enum(["base20", "digits"]).optional(),
		mask: e.string().max(20).optional()
	}).optional(),
	default_token_quota: e.object({
		clients: e.object({ client_credentials: e.record(e.string(), e.any()).optional() }).optional(),
		organizations: e.object({ client_credentials: e.record(e.string(), e.any()).optional() }).optional()
	}).nullish(),
	default_audience: e.string().optional(),
	default_organization: e.string().optional(),
	sessions: e.object({ oidc_logout_prompt_enabled: e.boolean().optional() }).optional(),
	oidc_logout: e.object({ rp_logout_end_session_endpoint_discovery: e.boolean().optional() }).optional(),
	allow_organization_name_in_authentication_api: e.boolean().optional(),
	customize_mfa_in_postlogin_action: e.boolean().optional(),
	acr_values_supported: e.array(e.string()).optional(),
	mtls: e.object({ enable_endpoint_aliases: e.boolean().optional() }).nullish(),
	pushed_authorization_requests_supported: e.boolean().optional(),
	authorization_response_iss_parameter_supported: e.boolean().optional(),
	deployment_type: e.enum(["shared", "wfp"]).default("shared").optional(),
	provisioning_state: e.enum([
		"pending",
		"ready",
		"failed"
	]).default("ready").optional(),
	provisioning_error: e.string().max(2048).optional(),
	provisioning_state_changed_at: e.string().optional(),
	bundle_configuration: e.string().max(64).optional(),
	worker_version: e.string().max(64).optional(),
	database_version: e.string().max(64).optional(),
	worker_script_name: e.string().max(255).optional(),
	storage_kind: e.enum([
		"own_d1",
		"existing_d1",
		"shared_planetscale"
	]).optional(),
	d1_database_id: e.string().max(64).optional(),
	attack_protection: mr.optional(),
	mfa: e.object({
		policy: e.enum(["never", "always"]).default("never").optional(),
		factors: e.object({
			sms: e.boolean().default(!1),
			otp: e.boolean().default(!1),
			email: e.boolean().default(!1),
			push_notification: e.boolean().default(!1),
			webauthn_roaming: e.boolean().default(!1),
			webauthn_platform: e.boolean().default(!1),
			recovery_code: e.boolean().default(!1),
			duo: e.boolean().default(!1)
		}).optional(),
		sms_provider: e.object({ provider: e.enum([
			"twilio",
			"vonage",
			"aws_sns",
			"phone_message_hook"
		]).optional() }).optional(),
		twilio: e.object({
			sid: e.string().optional(),
			auth_token: e.string().optional(),
			from: e.string().optional(),
			messaging_service_sid: e.string().optional()
		}).optional(),
		phone_message: e.object({ message: e.string().optional() }).optional()
	}).optional()
}), xr = e.object({
	created_at: e.string().nullable().transform((e) => e ?? ""),
	updated_at: e.string().nullable().transform((e) => e ?? "")
}).extend(br.shape).extend({
	id: e.string(),
	is_control_plane: e.boolean().optional(),
	has_children: e.boolean().optional()
}), Sr = e.enum([
	"provision",
	"seed",
	"upgrade",
	"backup",
	"deprovision",
	"users_import",
	"sync-defaults",
	"detach",
	"tenant-members-request"
]), Cr = e.enum([
	"pending",
	"running",
	"succeeded",
	"failed",
	"cancelled"
]), wr = e.string().max(64), Tr = ["inline", "cloudflare-workflows"], Er = e.object({
	tenant_id: e.string().max(255).nullable().default(null),
	rollout_id: e.string().max(255).nullable().optional(),
	kind: Sr,
	engine: wr,
	engine_instance_id: e.string().max(100).nullable().optional(),
	target_worker_version: e.string().max(255).nullable().optional(),
	target_database_version: e.string().max(255).nullable().optional(),
	initiated_by: e.string().max(255).nullable().optional(),
	input: e.record(e.string(), e.unknown()).nullable().optional()
}), Dr = Er.extend({
	id: e.string(),
	status: Cr,
	current_step: e.string().max(255).nullable().optional(),
	error: e.string().nullable().optional(),
	result: e.record(e.string(), e.unknown()).nullable().optional(),
	claimed_by: e.string().max(255).nullable().optional(),
	claim_expires_at: e.string().nullable().optional(),
	created_at: e.string(),
	updated_at: e.string(),
	finished_at: e.string().nullable().optional()
}), Or = Dr.pick({
	status: !0,
	current_step: !0,
	engine_instance_id: !0,
	target_worker_version: !0,
	target_database_version: !0,
	error: !0,
	result: !0,
	claimed_by: !0,
	claim_expires_at: !0,
	finished_at: !0
}).partial(), kr = e.enum([
	"started",
	"succeeded",
	"failed",
	"retried",
	"skipped",
	"reconciled"
]), Ar = e.object({
	operation_id: e.string().max(255),
	step: e.string().max(255),
	outcome: kr,
	detail: e.record(e.string(), e.unknown()).nullable().optional(),
	attempt: e.number().int().min(1).default(1)
}), jr = Ar.extend({
	id: e.string(),
	created_at: e.string()
}), U = e.enum([
	"pending",
	"inserted",
	"updated",
	"failed",
	"skipped"
]), Mr = [
	"inserted",
	"updated",
	"failed",
	"skipped"
], Nr = e.object({
	operation_id: e.string().max(255),
	seq: e.number().int().min(0),
	payload: e.record(e.string(), e.unknown()),
	status: U.default("pending"),
	error_code: e.string().max(64).nullable().optional(),
	error_message: e.string().nullable().optional(),
	error_path: e.string().max(255).nullable().optional(),
	entity_id: e.string().max(255).nullable().optional()
}), Pr = Nr.extend({
	status: U,
	created_at: e.string(),
	updated_at: e.string()
}), Fr = e.object({
	seq: e.number().int().min(0),
	status: U,
	error_code: e.string().max(64).nullable().optional(),
	error_message: e.string().nullable().optional(),
	error_path: e.string().max(255).nullable().optional(),
	entity_id: e.string().max(255).nullable().optional()
}), Ir = e.enum([
	"upgrade",
	"reseed",
	"backup",
	"config-sync"
]), Lr = e.enum([
	"pending",
	"canary",
	"rolling",
	"paused",
	"done",
	"failed"
]), Rr = e.object({
	kind: Ir,
	target_worker_version: e.string().max(255).nullable().optional(),
	target_database_version: e.string().max(255).nullable().optional(),
	wave_size: e.number().int().min(1).default(10),
	canary_tenant_ids: e.array(e.string()).nullable().optional(),
	filter: e.record(e.string(), e.unknown()).nullable().optional(),
	initiated_by: e.string().max(255).nullable().optional(),
	config: e.record(e.string(), e.unknown()).nullable().optional()
}), zr = Rr.extend({
	id: e.string(),
	status: Lr,
	created_at: e.string(),
	updated_at: e.string(),
	finished_at: e.string().nullable().optional(),
	paused_reason: e.string().nullable().optional()
}), Br = zr.pick({
	status: !0,
	wave_size: !0,
	canary_tenant_ids: !0,
	filter: !0,
	config: !0,
	paused_reason: !0,
	finished_at: !0
}).partial(), Vr = e.enum([
	"invite",
	"add_members",
	"remove_members",
	"assign_roles",
	"remove_roles",
	"revoke_invitation"
]), W = e.enum([
	"pending",
	"succeeded",
	"failed"
]), Hr = e.object({
	kind: Vr,
	requested_by: e.string().min(1).max(255),
	payload: e.record(e.string(), e.unknown())
}), Ur = Hr.extend({
	id: e.string(),
	tenant_id: e.string(),
	status: W,
	result: e.record(e.string(), e.unknown()).nullable().optional(),
	error: e.string().nullable().optional(),
	notified_at: e.string().nullable().optional(),
	created_at: e.string(),
	updated_at: e.string(),
	finished_at: e.string().nullable().optional()
}), Wr = e.object({
	status: W.optional(),
	result: e.record(e.string(), e.unknown()).nullable().optional(),
	error: e.string().nullable().optional(),
	notified_at: e.string().nullable().optional(),
	finished_at: e.string().nullable().optional()
}), Gr = /* @__PURE__ */ function(e) {
	return e.DeviceCode = "urn:ietf:params:oauth:grant-type:device_code", e.RefreshToken = "refresh_token", e.AuthorizationCode = "authorization_code", e.ClientCredential = "client_credentials", e.Passwordless = "passwordless", e.Password = "password", e.OTP = "http://auth0.com/oauth/grant-type/passwordless/otp", e.TokenExchange = "urn:ietf:params:oauth:grant-type:token-exchange", e;
}({}), Kr = e.object({
	access_token: e.string(),
	id_token: e.string().optional(),
	scope: e.string().optional(),
	state: e.string().optional(),
	refresh_token: e.string().optional(),
	token_type: e.string(),
	expires_in: e.number()
});
e.object({
	code: e.string(),
	state: e.string().optional()
});
//#endregion
//#region src/types/Theme.ts
var qr = e.object({
	button_border_radius: e.number(),
	button_border_weight: e.number(),
	buttons_style: e.enum([
		"pill",
		"rounded",
		"sharp"
	]),
	input_border_radius: e.number(),
	input_border_weight: e.number(),
	inputs_style: e.enum([
		"pill",
		"rounded",
		"sharp"
	]),
	show_widget_shadow: e.boolean(),
	widget_border_weight: e.number(),
	widget_corner_radius: e.number()
}), Jr = e.object({
	base_focus_color: e.string(),
	base_hover_color: e.string(),
	body_text: e.string(),
	captcha_widget_theme: e.enum([
		"auto",
		"dark",
		"light"
	]),
	error: e.string(),
	header: e.string(),
	icons: e.string(),
	input_background: e.string(),
	input_border: e.string(),
	input_filled_text: e.string(),
	input_labels_placeholders: e.string(),
	links_focused_components: e.string(),
	primary_button: e.string(),
	primary_button_label: e.string(),
	secondary_button_border: e.string(),
	secondary_button_label: e.string(),
	success: e.string(),
	widget_background: e.string(),
	widget_border: e.string()
}), G = e.object({
	bold: e.boolean(),
	size: e.number()
}), Yr = e.object({
	body_text: G,
	buttons_text: G,
	font_url: e.string(),
	input_labels: G,
	links: G,
	links_style: e.enum(["normal", "underlined"]),
	reference_text_size: e.number(),
	subtitle: G,
	title: G
}), Xr = e.object({
	background_color: e.string(),
	background_image_url: e.string(),
	page_layout: e.enum([
		"center",
		"left",
		"right"
	]),
	logo_placement: e.enum([
		"widget",
		"chip",
		"none"
	]).optional()
}), Zr = e.object({
	header_text_alignment: e.enum([
		"center",
		"left",
		"right"
	]),
	logo_height: e.number(),
	logo_position: e.enum([
		"center",
		"left",
		"none",
		"right"
	]),
	logo_url: e.string(),
	social_buttons_layout: e.enum(["bottom", "top"])
}), Qr = e.object({
	borders: qr,
	colors: Jr,
	displayName: e.string(),
	fonts: Yr,
	page_background: Xr,
	widget: Zr
}), $r = Qr.extend({ themeId: e.string() }), ei = e.object({
	...i,
	universal_login_experience: e.enum(["new", "classic"]).default("new"),
	identifier_first: e.boolean().default(!0),
	password_first: e.boolean().default(!1),
	show_last_used_connection: e.boolean().default(!1),
	webauthn_platform_first_factor: e.boolean()
}), ti = e.object({
	hosts: e.array(e.string()).optional(),
	methods: e.array(e.string()).optional(),
	path: e.string().default("/*"),
	headers: e.record(e.string(), e.string()).optional(),
	query: e.record(e.string(), e.string()).optional()
}), ni = e.object({
	type: e.string(),
	options: e.record(e.string(), e.unknown()).default({})
}), K = e.object({
	id: e.string().optional(),
	custom_domain_id: e.string(),
	priority: e.number().int().default(100),
	match: ti,
	handlers: e.array(ni).min(1)
}), ri = K.extend({
	id: e.string(),
	tenant_id: e.string(),
	created_at: e.string(),
	updated_at: e.string()
}), ii = K.partial().omit({
	id: !0,
	custom_domain_id: !0
}), ai = "custom_authentication", oi = [
	"urn:ietf:params:oauth:",
	"urn:auth0",
	"urn:okta",
	"http://auth0.com",
	"https://auth0.com",
	"http://okta.com",
	"https://okta.com"
], q = e.string().min(1).max(200).refine((e) => e.startsWith("https://") || e.startsWith("urn:"), { message: "subject_token_type must be a URI starting with https:// or urn:" }).refine((e) => !oi.some((t) => e.toLowerCase().startsWith(t)), { message: "subject_token_type uses a reserved namespace" }), si = e.enum([
	"RS256",
	"RS384",
	"RS512",
	"ES256",
	"ES384",
	"ES512"
]), ci = e.discriminatedUnion("type", [e.object({
	type: e.literal("connection"),
	connection: e.string().min(1),
	create_if_not_exists: e.boolean().default(!0),
	trust_email_verified: e.boolean().default(!1)
}), e.object({ type: e.literal("user_id") })]), J = e.object({
	issuer: e.string().min(1).max(2048),
	jwks: Hn.optional(),
	jwks_uri: e.string().url().optional(),
	audience: e.array(e.string().min(1)).min(1).optional(),
	algorithms: e.array(si).min(1).optional(),
	max_lifetime_seconds: e.number().int().min(1).max(3600).default(300),
	require_jti: e.boolean().default(!0),
	user_mapping: ci
}), li = e.object({
	name: e.string().min(1).max(255),
	subject_token_type: q,
	action_id: e.string().min(1).optional(),
	type: e.literal(ai),
	jwt_verification: J.optional()
}), ui = li.extend({
	id: e.string(),
	created_at: e.string(),
	updated_at: e.string()
}), di = e.object({
	name: e.string().min(1).max(255).optional(),
	subject_token_type: q.optional(),
	jwt_verification: J.optional()
}), fi = e.object({
	scim: e.string(),
	auth0: e.string()
}), pi = e.object({
	connection_id: e.string(),
	user_id_attribute: e.string().default("externalId"),
	mapping: e.array(fi).default([])
}), mi = e.object({
	created_at: e.string(),
	updated_at: e.string()
}).extend(pi.shape), hi = e.object({
	token_id: e.string(),
	connection_id: e.string(),
	token_hash: e.string(),
	scopes: e.array(e.string()).default([]),
	valid_until: e.string().optional()
}), gi = e.object({
	created_at: e.string(),
	last_used_at: e.string().optional()
}).extend(hi.shape), _i = e.object({
	connection_id: e.string(),
	external_id: e.string(),
	user_id: e.string()
}), vi = e.object({ created_at: e.string() }).extend(_i.shape), yi = e.object({
	...i,
	name: e.string(),
	enabled: e.boolean().optional().default(!0),
	default_from_address: e.string().optional(),
	credentials: e.record(e.string(), e.unknown()),
	settings: e.object({}).optional()
}), bi = e.enum([
	"verify_email",
	"verify_email_by_code",
	"reset_email",
	"reset_email_by_code",
	"welcome_email",
	"blocked_account",
	"stolen_credentials",
	"enrollment_email",
	"mfa_oob_code",
	"change_password",
	"password_reset",
	"user_invitation"
]), xi = e.object({
	template: bi,
	body: e.string(),
	from: e.string(),
	subject: e.string(),
	syntax: e.literal("liquid").default("liquid"),
	resultUrl: e.string().optional(),
	urlLifetimeInSeconds: e.number().int().nonnegative().optional(),
	includeEmailInRedirect: e.boolean().default(!1),
	enabled: e.boolean().default(!0)
}), Si = e.object({
	id: e.string(),
	login_id: e.string(),
	session_id: e.string().optional(),
	organization: e.string().optional(),
	auth_connection: e.string().optional(),
	auth_strategy: z.optional(),
	user_id: e.string(),
	client_id: e.string(),
	expires_at: e.string().optional(),
	idle_expires_at: e.string().optional(),
	last_exchanged_at: e.string().optional(),
	device: H,
	resource_servers: e.array(e.object({
		audience: e.string(),
		scopes: e.string()
	})),
	rotating: e.boolean(),
	token_lookup: e.string().optional(),
	token_hash: e.string().optional(),
	family_id: e.string().optional(),
	rotated_to: e.string().optional(),
	rotated_at: e.string().optional()
}), Ci = Si.extend({
	created_at: e.string(),
	revoked_at: e.string().optional()
}), wi = e.object({
	to: e.string(),
	message: e.string()
}), Ti = e.object({
	name: e.string(),
	options: e.object({})
}), Ei = e.object({
	value: e.string(),
	description: e.string().optional()
}), Di = e.object({
	token_dialect: e.enum(["access_token", "access_token_authz"]).optional(),
	enforce_policies: e.boolean().optional(),
	allow_skipping_userinfo: e.boolean().optional(),
	skip_userinfo: e.boolean().optional(),
	persist_client_authorization: e.boolean().optional(),
	enable_introspection_endpoint: e.boolean().optional(),
	mtls: e.object({ bound_access_tokens: e.boolean().optional() }).optional()
}), Oi = e.object({
	id: e.string().optional(),
	name: e.string(),
	identifier: e.string(),
	scopes: e.array(Ei).optional(),
	signing_alg: e.string().optional(),
	signing_secret: e.string().optional(),
	token_lifetime: e.number().default(86400),
	token_lifetime_for_web: e.number().default(7200),
	skip_consent_for_verifiable_first_party_clients: e.boolean().optional(),
	allow_offline_access: e.boolean().optional(),
	verificationKey: e.string().optional(),
	options: Di.optional(),
	is_system: e.boolean().optional(),
	...i,
	metadata: e.record(e.string(), e.any()).optional()
}), ki = Oi.extend({
	created_at: e.string().optional(),
	updated_at: e.string().optional()
}), Ai = e.array(ki), ji = e.object({
	role_id: e.string(),
	resource_server_identifier: e.string(),
	permission_name: e.string()
}), Mi = ji.extend({ created_at: e.string() }), Ni = e.array(Mi), Pi = e.object({
	user_id: e.string().openapi({ description: "The id of the user that granted the consent" }),
	clientID: e.string().openapi({ description: "The id of the client the grant was issued to" }),
	audience: e.string().optional().openapi({ description: "The audience the grant applies to" }),
	scope: e.array(e.string()).default([]).openapi({ description: "The list of OAuth scopes the user has consented to" })
}), Fi = Pi.extend({ id: e.string() }), Ii = e.object({
	user_id: e.string(),
	last_login: e.string().optional(),
	last_ip: e.string().optional(),
	login_count: e.number().default(0),
	failed_logins: e.array(e.string()).optional(),
	last_password_reset: e.string().optional()
}), Li = e.object({
	user_id: e.string(),
	resource_server_identifier: e.string(),
	permission_name: e.string(),
	organization_id: e.string().optional()
}), Ri = Li.extend({
	tenant_id: e.string(),
	created_at: e.string().optional()
}), zi = e.array(Ri), Bi = e.object({
	user_id: e.string(),
	resource_server_identifier: e.string(),
	resource_server_name: e.string(),
	permission_name: e.string(),
	description: e.string().nullable().optional(),
	created_at: e.string().optional(),
	organization_id: e.string().optional()
}), Vi = e.array(Bi), Hi = e.object({
	user_id: e.string(),
	role_id: e.string(),
	organization_id: e.string().optional()
}), Ui = Hi.extend({
	tenant_id: e.string(),
	created_at: e.string().optional()
}), Wi = e.array(Ui), Gi = e.object({
	id: e.string().optional().openapi({ description: "The unique identifier of the role. If not provided, one will be generated." }),
	name: e.string().min(1).max(50).openapi({ description: "The name of the role. Cannot include '<' or '>'" }),
	description: e.string().max(255).optional().openapi({ description: "The description of the role" }),
	is_system: e.boolean().optional(),
	metadata: e.record(e.string(), e.any()).optional().openapi({ description: "Metadata associated with the role. Can be used to control sync behavior in multi-tenancy scenarios." })
}), Ki = Gi.extend({
	id: e.string().openapi({ description: "The unique identifier of the role" }),
	created_at: e.string().optional(),
	updated_at: e.string().optional()
}), qi = e.array(Ki), Ji = e.object({
	logo_url: e.string().optional().openapi({ description: "URL of the organization's logo" }),
	colors: e.object({
		primary: e.string().optional().openapi({ description: "Primary color in hex format (e.g., #FF0000)" }),
		page_background: e.string().optional().openapi({ description: "Page background color in hex format (e.g., #FFFFFF)" })
	}).optional()
}).optional(), Yi = e.object({
	connection_id: e.string().openapi({ description: "ID of the connection" }),
	assign_membership_on_login: e.boolean().default(!1).openapi({ description: "Whether to assign membership to the organization on login" }),
	show_as_button: e.boolean().default(!0).openapi({ description: "Whether to show this connection as a button in the login screen" }),
	is_signup_enabled: e.boolean().default(!0).openapi({ description: "Whether signup is enabled for this connection" })
}), Xi = e.object({ client_credentials: e.object({
	enforce: e.boolean().default(!1).openapi({ description: "Whether to enforce token quota limits" }),
	per_day: e.number().min(0).default(0).openapi({ description: "Maximum tokens per day (0 = unlimited)" }),
	per_hour: e.number().min(0).default(0).openapi({ description: "Maximum tokens per hour (0 = unlimited)" })
}).optional() }).optional(), Zi = e.object({
	id: e.string().optional(),
	name: e.string().min(1).regex(/^[a-z0-9_-]+$/, { message: "Organization name must be lowercase and can only contain letters, numbers, hyphens, and underscores" }).openapi({ description: "The name of the organization. Must be lowercase and can only contain letters, numbers, hyphens, and underscores." }),
	display_name: e.string().optional().openapi({ description: "The display name of the organization" }),
	branding: Ji,
	metadata: e.record(e.string(), e.any()).default({}).optional().openapi({ description: "Custom metadata for the organization" }),
	enabled_connections: e.array(Yi).default([]).optional().openapi({ description: "List of enabled connections for the organization" }),
	token_quota: Xi
}), Qi = Zi.extend(t.shape).extend({
	id: e.string(),
	name: e.string().min(1).openapi({ description: "The name of the organization" })
}), $i = e.object({
	connection_id: e.string().openapi({ description: "ID of the tenant-level connection to enable for the org." }),
	assign_membership_on_login: e.boolean().optional().default(!1),
	show_as_button: e.boolean().optional().default(!0),
	is_signup_enabled: e.boolean().optional().default(!0)
}), ea = $i.extend({
	connection: e.object({
		name: e.string().optional(),
		strategy: e.string().optional()
	}).optional(),
	created_at: e.string().optional(),
	updated_at: e.string().optional()
}), ta = e.array(ea), na = e.object({
	user_id: e.string().openapi({ description: "ID of the user" }),
	organization_id: e.string().openapi({ description: "ID of the organization" })
}), ra = na.extend(t.shape).extend({ id: e.string() }), ia = e.object({
	idle_session_lifetime: e.number().default(72),
	session_lifetime: e.number().default(168),
	session_cookie: e.object({ mode: e.enum(["persistent", "non-persistent"]).optional() }).optional(),
	enable_client_connections: e.boolean().optional(),
	default_redirection_uri: e.string().optional(),
	enabled_locales: e.array(e.string()).optional(),
	default_directory: e.string().optional(),
	error_page: e.object({
		html: e.string().optional(),
		show_log_link: e.boolean().optional(),
		url: e.string().optional()
	}).optional(),
	flags: e.object({
		allow_legacy_delegation_grant_types: e.boolean().optional(),
		allow_legacy_ro_grant_types: e.boolean().optional(),
		allow_legacy_tokeninfo_endpoint: e.boolean().optional(),
		disable_clickjack_protection_headers: e.boolean().optional(),
		enable_apis_section: e.boolean().optional(),
		enable_client_connections: e.boolean().optional(),
		enable_custom_domain_in_emails: e.boolean().optional(),
		enable_dynamic_client_registration: e.boolean().optional(),
		enable_idtoken_api2: e.boolean().optional(),
		enable_legacy_logs_search_v2: e.boolean().optional(),
		enable_legacy_profile: e.boolean().optional(),
		enable_pipeline2: e.boolean().optional(),
		enable_public_signup_user_exists_error: e.boolean().optional(),
		use_scope_descriptions_for_consent: e.boolean().optional(),
		disable_management_api_sms_obfuscation: e.boolean().optional(),
		enable_adfs_waad_email_verification: e.boolean().optional(),
		revoke_refresh_token_grant: e.boolean().optional(),
		dashboard_log_streams_next: e.boolean().optional(),
		dashboard_insights_view: e.boolean().optional(),
		disable_fields_map_fix: e.boolean().optional(),
		mfa_show_factor_list_on_enrollment: e.boolean().optional()
	}).optional(),
	friendly_name: e.string().optional(),
	picture_url: e.string().optional(),
	support_email: e.string().optional(),
	support_url: e.string().optional(),
	sandbox_version: e.string().optional(),
	sandbox_versions_available: e.array(e.string()).optional(),
	change_password: e.object({
		enabled: e.boolean(),
		html: e.string()
	}).optional(),
	guardian_mfa_page: e.object({
		enabled: e.boolean(),
		html: e.string()
	}).optional(),
	default_audience: e.string().optional(),
	default_organization: e.string().optional(),
	sessions: e.object({ oidc_logout_prompt_enabled: e.boolean().optional() }).optional(),
	mfa: e.object({
		policy: e.enum(["never", "always"]).default("never").optional(),
		factors: e.object({
			sms: e.boolean().default(!1),
			otp: e.boolean().default(!1),
			email: e.boolean().default(!1),
			push_notification: e.boolean().default(!1),
			webauthn_roaming: e.boolean().default(!1),
			webauthn_platform: e.boolean().default(!1),
			recovery_code: e.boolean().default(!1),
			duo: e.boolean().default(!1)
		}).optional(),
		sms_provider: e.object({ provider: e.enum([
			"twilio",
			"vonage",
			"aws_sns",
			"phone_message_hook"
		]).optional() }).optional(),
		twilio: e.object({
			sid: e.string().optional(),
			auth_token: e.string().optional(),
			from: e.string().optional(),
			messaging_service_sid: e.string().optional()
		}).optional(),
		phone_message: e.object({ message: e.string().optional() }).optional()
	}).optional()
}), aa = e.object({
	date: e.string().openapi({
		description: "Date these events occurred in ISO 8601 format",
		example: "2025-12-19"
	}),
	logins: e.number().openapi({
		description: "Number of logins on this date",
		example: 150
	}),
	signups: e.number().openapi({
		description: "Number of signups on this date",
		example: 25
	}),
	leaked_passwords: e.number().openapi({
		description: "Number of breached-password detections on this date (subscription required)",
		example: 0
	}),
	updated_at: e.string().openapi({
		description: "Date and time this stats entry was last updated in ISO 8601 format",
		example: "2025-12-19T10:30:00.000Z"
	}),
	created_at: e.string().openapi({
		description: "Approximate date and time the first event occurred in ISO 8601 format",
		example: "2025-12-19T00:00:00.000Z"
	})
}), oa = e.number().openapi({
	description: "Number of active users in the last 30 days",
	example: 1234
}), sa = e.enum([
	"active-users",
	"logins",
	"signups",
	"refresh-tokens",
	"sessions",
	"logouts",
	"password-changes",
	"password-migrations",
	"mfa",
	"email-verifications",
	"codes-sent"
]), ca = e.enum([
	"hour",
	"day",
	"week",
	"month"
]), la = e.enum([
	"time",
	"connection",
	"client_id",
	"user_type",
	"event"
]), ua = e.enum([
	"password",
	"social",
	"passwordless",
	"enterprise"
]), da = e.object({
	cohort: e.string(),
	sessions: e.number(),
	active: e.array(e.number())
}), fa = e.object({
	interval: e.literal("week"),
	from: e.string(),
	to: e.string(),
	cohorts: e.array(da)
}), pa = e.object({
	cohort: e.string(),
	tokens: e.number(),
	active: e.array(e.number())
}), ma = e.object({
	interval: e.literal("week"),
	from: e.string(),
	to: e.string(),
	cohorts: e.array(pa)
}), ha = e.object({
	name: e.string(),
	type: e.string()
}), ga = e.object({
	elapsed: e.number(),
	rows_read: e.number().optional(),
	bytes_read: e.number().optional()
}), _a = e.object({
	meta: e.array(ha),
	data: e.array(e.record(e.string(), e.any())),
	rows: e.number(),
	rows_before_limit_at_least: e.number().optional(),
	statistics: ga.optional()
}), va = e.enum(/* @__PURE__ */ "login.login-id.login-password.signup.signup-id.signup-password.reset-password.consent.mfa.mfa-push.mfa-otp.mfa-voice.mfa-phone.mfa-webauthn.mfa-email.mfa-recovery-code.status.device-flow.email-verification.email-otp-challenge.organizations.invitation.common.passkeys.captcha.custom-form.login-passwordless.mfa-login-options".split(".")), ya = e.record(e.string(), e.record(e.string(), e.string())).openapi({
	type: "object",
	additionalProperties: {
		type: "object",
		additionalProperties: { type: "string" }
	}
}), ba = e.object({
	prompt: va,
	language: e.string(),
	custom_text: ya
}), xa = [
	"form-content-start",
	"form-content-end",
	"form-footer-start",
	"form-footer-end",
	"secondary-actions-start",
	"secondary-actions-end"
], Sa = e.object({
	"form-content-start": e.string().optional(),
	"form-content-end": e.string().optional(),
	"form-footer-start": e.string().optional(),
	"form-footer-end": e.string().optional(),
	"secondary-actions-start": e.string().optional(),
	"secondary-actions-end": e.string().optional()
}).strict(), Ca = e.record(e.string(), Sa), wa = e.object({
	prompt: e.string(),
	partials: Ca
}), Ta = {
	EMAIL: "email",
	SMS: "sms",
	USERNAME_PASSWORD: "Username-Password-Authentication",
	GOOGLE_OAUTH2: "google-oauth2",
	APPLE: "apple",
	FACEBOOK: "facebook",
	GITHUB: "github",
	WINDOWSLIVE: "windowslive",
	VIPPS: "vipps",
	OIDC: "oidc",
	OAUTH2: "oauth2",
	SAMLP: "samlp",
	WAAD: "waad",
	ADFS: "adfs",
	OKTA: "okta"
}, Ea = {
	DATABASE: "database",
	SOCIAL: "social",
	PASSWORDLESS: "passwordless"
}, Da = "auth0";
function Oa(e) {
	return e === "auth0" || e === Ta.USERNAME_PASSWORD || e === "auth2";
}
//#endregion
//#region src/types/AuthenticationMethod.ts
var ka = e.enum([
	"phone",
	"totp",
	"email",
	"push",
	"webauthn-roaming",
	"webauthn-platform",
	"passkey"
]), Aa = e.object({
	user_id: e.string(),
	type: ka,
	phone_number: e.string().optional(),
	totp_secret: e.string().optional(),
	credential_id: e.string().optional(),
	public_key: e.string().optional(),
	sign_count: e.number().int().nonnegative().optional(),
	credential_backed_up: e.boolean().optional(),
	transports: e.array(e.string()).optional(),
	friendly_name: e.string().optional(),
	confirmed: e.boolean().default(!1)
});
function ja(t, n) {
	t.type === "phone" && !t.phone_number && n.addIssue({
		code: e.ZodIssueCode.custom,
		message: "phone_number is required when type is 'phone'",
		path: ["phone_number"]
	}), t.type === "totp" && !t.totp_secret && n.addIssue({
		code: e.ZodIssueCode.custom,
		message: "totp_secret is required when type is 'totp'",
		path: ["totp_secret"]
	}), [
		"webauthn-roaming",
		"webauthn-platform",
		"passkey"
	].includes(t.type) && (t.credential_id || n.addIssue({
		code: e.ZodIssueCode.custom,
		message: `credential_id is required when type is '${t.type}'`,
		path: ["credential_id"]
	}), t.public_key || n.addIssue({
		code: e.ZodIssueCode.custom,
		message: `public_key is required when type is '${t.type}'`,
		path: ["public_key"]
	}));
}
var Ma = Aa.superRefine(ja), Na = Aa.extend({
	id: e.string(),
	created_at: e.string(),
	updated_at: e.string()
}).superRefine(ja), Pa = e.object({
	id: e.string().optional(),
	created_at: e.string().datetime({ offset: !0 }).optional(),
	updated_at: e.string().datetime({ offset: !0 }).optional()
}), Fa = {
	"validate-registration-username": { access: ["deny"] },
	"post-user-login": {
		accessToken: ["setCustomClaim"],
		idToken: ["setCustomClaim"],
		access: ["deny"],
		prompt: ["render"],
		redirect: ["sendUserTo"],
		user: ["setLinkedTo"]
	},
	"credentials-exchange": {
		accessToken: ["setCustomClaim"],
		idToken: ["setCustomClaim"],
		access: ["deny"]
	},
	"pre-user-registration": {
		user: [
			"setUserMetadata",
			"setAppMetadata",
			"setLinkedTo"
		],
		access: ["deny"],
		validation: ["error"]
	},
	"post-user-registration": {},
	"pre-user-update": { access: ["deny"] },
	"post-user-update": {},
	"pre-user-deletion": { access: ["deny"] },
	"post-user-deletion": {},
	"custom-token-exchange": {
		authentication: ["setUserById", "setUserByConnection"],
		access: ["deny", "rejectInvalidSubjectToken"]
	}
}, Ia = {
	"validate-registration-username": "onExecuteValidateRegistrationUsername",
	"post-user-login": "onExecutePostLogin",
	"credentials-exchange": "onExecuteCredentialsExchange",
	"pre-user-registration": "onExecutePreUserRegistration",
	"post-user-registration": "onExecutePostUserRegistration",
	"pre-user-update": "onExecutePreUserUpdate",
	"post-user-update": "onExecutePostUserUpdate",
	"pre-user-deletion": "onExecutePreUserDeletion",
	"post-user-deletion": "onExecutePostUserDeletion",
	"custom-token-exchange": "onExecuteCustomTokenExchange"
}, Y = {
	"validate-registration-username": "// Code Action sandbox API. Calls are recorded and applied after the handler completes; methods return no result.\n\ninterface ActionBlockingAccessAPI {\n    /** Cancel registration, update, or deletion with an optional reason. */\n    deny(reason?: string): void;\n}\n\ntype ActionAPI = {\n    access: ActionBlockingAccessAPI;\n};",
	"post-user-login": "// Code Action sandbox API. Calls are recorded and applied after the handler completes; methods return no result.\n\ninterface ActionClaimAPI {\n    /** Values must be JSON serializable. Reserved token claims cannot be set. */\n    setCustomClaim(claim: string, value: unknown): void;\n}\n\ninterface ActionAccessAPI {\n    /** Deny with an error code and an optional human-readable reason. */\n    deny(code: string, reason?: string): void;\n}\n\ninterface ActionLinkAPI {\n    /** Records a link request; does not return a user or immediately mutate event.user. */\n    setLinkedTo(primaryUserId: string): void;\n}\n\ntype ActionAPI = {\n    accessToken: ActionClaimAPI;\n    idToken: ActionClaimAPI;\n    access: ActionAccessAPI;\n    prompt: {\n        render(formId: string): void;\n    };\n    redirect: {\n        sendUserTo(url: string, options?: {\n            query?: Record<string, string>;\n        }): void;\n    };\n    user: ActionLinkAPI;\n};",
	"credentials-exchange": "// Code Action sandbox API. Calls are recorded and applied after the handler completes; methods return no result.\n\ninterface ActionClaimAPI {\n    /** Values must be JSON serializable. Reserved token claims cannot be set. */\n    setCustomClaim(claim: string, value: unknown): void;\n}\n\ninterface ActionAccessAPI {\n    /** Deny with an error code and an optional human-readable reason. */\n    deny(code: string, reason?: string): void;\n}\n\ntype ActionAPI = {\n    accessToken: ActionClaimAPI;\n    idToken: ActionClaimAPI;\n    access: ActionAccessAPI;\n};",
	"pre-user-registration": "// Code Action sandbox API. Calls are recorded and applied after the handler completes; methods return no result.\n\ninterface ActionRegistrationUserAPI extends ActionLinkAPI {\n    /** Metadata values must be JSON serializable. */\n    setUserMetadata(key: string, value: unknown): void;\n    setAppMetadata(key: string, value: unknown): void;\n}\n\ninterface ActionLinkAPI {\n    /** Records a link request; does not return a user or immediately mutate event.user. */\n    setLinkedTo(primaryUserId: string): void;\n}\n\ninterface ActionAccessAPI {\n    /** Deny with an error code and an optional human-readable reason. */\n    deny(code: string, reason?: string): void;\n}\n\ntype ActionAPI = {\n    user: ActionRegistrationUserAPI;\n    access: ActionAccessAPI;\n    validation: {\n        error(code: string, message: string): void;\n    };\n};",
	"post-user-registration": "// Code Action sandbox API. Calls are recorded and applied after the handler completes; methods return no result.\n\ntype ActionAPI = {};",
	"pre-user-update": "// Code Action sandbox API. Calls are recorded and applied after the handler completes; methods return no result.\n\ninterface ActionBlockingAccessAPI {\n    /** Cancel registration, update, or deletion with an optional reason. */\n    deny(reason?: string): void;\n}\n\ntype ActionAPI = {\n    access: ActionBlockingAccessAPI;\n};",
	"post-user-update": "// Code Action sandbox API. Calls are recorded and applied after the handler completes; methods return no result.\n\ntype ActionAPI = {};",
	"pre-user-deletion": "// Code Action sandbox API. Calls are recorded and applied after the handler completes; methods return no result.\n\ninterface ActionBlockingAccessAPI {\n    /** Cancel registration, update, or deletion with an optional reason. */\n    deny(reason?: string): void;\n}\n\ntype ActionAPI = {\n    access: ActionBlockingAccessAPI;\n};",
	"post-user-deletion": "// Code Action sandbox API. Calls are recorded and applied after the handler completes; methods return no result.\n\ntype ActionAPI = {};",
	"custom-token-exchange": "// Code Action sandbox API. Calls are recorded and applied after the handler completes; methods return no result.\n\ninterface ActionExchangeUserAttributes {\n    /** The user's id within the named connection, not a full AuthHero user_id. */\n    user_id: string;\n    email?: string;\n    email_verified?: boolean;\n    phone_number?: string;\n    phone_verified?: boolean;\n    username?: string;\n    name?: string;\n    given_name?: string;\n    family_name?: string;\n    nickname?: string;\n    picture?: string;\n}\n\ninterface ActionExchangeUserOptions {\n    /** Defaults to create_if_not_exists. */\n    creationBehavior?: \"create_if_not_exists\" | \"none\";\n    /** Defaults to none. */\n    updateBehavior?: \"replace\" | \"none\";\n}\n\ntype ActionAPI = {\n    /** Validate the subject token, then call exactly one user selector or reject it. */\n    authentication: {\n        /** Select an existing full AuthHero user_id. */\n        setUserById(userId: string): void;\n        /** Select a user by connection name and validated user attributes. */\n        setUserByConnection(connection: string, attributes: ActionExchangeUserAttributes, options?: ActionExchangeUserOptions): void;\n    };\n    access: {\n        deny(code: string, reason?: string): void;\n        rejectInvalidSubjectToken(reason?: string): void;\n    };\n};"
};
function La(e) {
	let t = e === "post-login" ? "post-user-login" : e;
	if (!Object.hasOwn(Y, t)) throw Error(`Unsupported action trigger: ${e}`);
	return Y[t];
}
//#endregion
//#region src/utils/user-id.ts
function Ra(e) {
	let t = e.indexOf("|"), n = e.slice(0, t), r = e.slice(t + 1);
	if (t === -1 || !n || !r) throw Error(`Invalid user_id: ${e}`);
	return {
		connection: n,
		id: r
	};
}
//#endregion
//#region src/utils/http.ts
var za = "x-authhero-preserve-location";
//#endregion
//#region src/utils/passthrough.ts
function Ba(e) {
	let { primary: t, secondaries: n, syncMethods: r = [
		"create",
		"rawCreate",
		"update",
		"remove",
		"delete",
		"set"
	] } = e;
	return new Proxy(t, { get(e, t) {
		if (typeof t == "symbol") return e[t];
		let i = e[t];
		return typeof i == "function" ? r.includes(t) ? async (...r) => {
			let a = await i.apply(e, r), o = [];
			for (let e of n) {
				let n = e.adapter[t];
				if (typeof n != "function") continue;
				let i = (async () => {
					try {
						await n.apply(e.adapter, r);
					} catch (n) {
						try {
							e.onError ? e.onError(n, t, r) : console.error(`Passthrough adapter: secondary write failed for ${t}:`, n);
						} catch (e) {
							console.error(`Passthrough adapter: onError handler threw for ${t}:`, e);
						}
					}
				})();
				e.blocking && o.push(i);
			}
			return o.length > 0 && await Promise.all(o), a;
		} : i.bind(e) : i;
	} });
}
function Va(e) {
	return e;
}
//#endregion
//#region src/utils/connection-attributes.ts
function Ha(e) {
	let t = e?.options;
	if (!t) return {
		usernameIdentifierActive: !1,
		emailIdentifierActive: !0,
		usernameMinLength: 1,
		usernameMaxLength: 15
	};
	let n = t.attributes;
	return n ? {
		usernameIdentifierActive: n.username?.identifier?.active === !0,
		emailIdentifierActive: n.email?.identifier?.active !== !1,
		usernameMinLength: n.username?.validation?.min_length ?? 1,
		usernameMaxLength: n.username?.validation?.max_length ?? 15
	} : {
		usernameIdentifierActive: t.requires_username === !0,
		emailIdentifierActive: !0,
		usernameMinLength: t.validation?.username?.min ?? 1,
		usernameMaxLength: t.validation?.username?.max ?? 15
	};
}
//#endregion
//#region src/utils/guards.ts
function Ua(e) {
	return typeof e == "object" && !!e && !Array.isArray(e);
}
//#endregion
//#region src/utils/base64url.ts
function Wa(e) {
	let t = "";
	for (let n of e) t += String.fromCharCode(n);
	return btoa(t).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function Ga(e) {
	let t = e.replace(/-/g, "+").replace(/_/g, "/"), n = atob(t), r = new Uint8Array(n.length);
	for (let e = 0; e < n.length; e++) r[e] = n.charCodeAt(e);
	return r;
}
function Ka(e) {
	return Wa(new TextEncoder().encode(e));
}
function qa(e) {
	return new TextDecoder().decode(Ga(e));
}
//#endregion
//#region src/utils/base64.ts
function Ja(e) {
	let t = "";
	for (let n of e) t += String.fromCharCode(n);
	return btoa(t);
}
function Ya(e) {
	let t = atob(e), n = new Uint8Array(t.length);
	for (let e = 0; e < t.length; e++) n[e] = t.charCodeAt(e);
	return n;
}
//#endregion
//#region src/utils/base32.ts
var X = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567";
function Xa(e) {
	let t = "", n = 0, r = 0;
	for (let i of e) for (n = n << 8 | i, r += 8; r >= 5;) r -= 5, t += X[n >> r & 31];
	return r > 0 && (t += X[n << 5 - r & 31]), t;
}
function Za(e) {
	let t = e.replace(/=+$/, "").toUpperCase(), n = t.length % 8;
	if (n === 1 || n === 3 || n === 6) throw Error(`Invalid base32 length: ${t.length}`);
	let r = [], i = 0, a = 0;
	for (let e of t) {
		let t = X.indexOf(e);
		if (t === -1) throw Error(`Invalid base32 character: ${e}`);
		i = i << 5 | t, a += 5, a >= 8 && (a -= 8, r.push(i >> a & 255));
	}
	if (a > 0 && i & (1 << a) - 1) throw Error("Invalid base32: non-zero trailing bits");
	return new Uint8Array(r);
}
//#endregion
//#region src/utils/hex.ts
function Qa(e) {
	let t = e instanceof Uint8Array ? e : new Uint8Array(e), n = "";
	for (let e of t) n += e.toString(16).padStart(2, "0");
	return n;
}
//#endregion
//#region src/utils/cursor.ts
function $a(e) {
	return Ka(JSON.stringify(e));
}
function eo(e) {
	try {
		let t = JSON.parse(qa(e));
		return t && typeof t == "object" && typeof t.i == "string" ? t : null;
	} catch {
		return null;
	}
}
//#endregion
//#region src/utils/lucene.ts
function to(e) {
	let t = [], n = "", r = !1;
	for (let i = 0; i < e.length; i++) {
		let a = e[i];
		a === "\\" && i + 1 < e.length ? (n += a + e[i + 1], i++) : a === "\"" ? (r = !r, n += a) : a === " " && !r ? (n.trim() && t.push(n.trim()), n = "") : n += a;
	}
	return n.trim() && t.push(n.trim()), t;
}
function no(e) {
	return e.replace(/\\([\\"+\-!(){}[\]^~*?:/&|])/g, "$1");
}
function ro(e) {
	return `"${e.replace(/([\\"])/g, "\\$1")}"`;
}
function io(e) {
	let t = e.trim();
	return no(t.length > 1 && t.startsWith("\"") && t.endsWith("\"") ? t.slice(1, -1) : t);
}
function ao(e) {
	let t = [], n = [];
	for (let r of to(e)) /^or$/i.test(r) ? (t.push(n), n = []) : n.push(r);
	return t.push(n), t.filter((e) => e.length > 0);
}
function oo(e, t) {
	let n = new Set(t), r = (e) => {
		let t = e.replace(/^([^:]+)=/, "$1:"), r = t.startsWith("-") ? t.slice(1) : t;
		if (r.startsWith("_exists_:")) return n.has(r.slice(9));
		let i = r.indexOf(":");
		return i > 0 ? n.has(r.slice(0, i)) : !0;
	};
	return ao(e).map((e) => e.filter(r).join(" ")).filter((e) => e.length > 0).join(" OR ");
}
var so = /^[^\s@%_*?"'()[\]{}^~:\\/]+@[^\s@%_*?"'()[\]{}^~:\\/]+\.[^\s@%_*?"'()[\]{}^~:\\/]+$/;
function co(e) {
	return so.test(e);
}
//#endregion
//#region src/utils/session-retention.ts
var Z = 10080 * 60 * 1e3, Q = 4320 * 60 * 1e3;
function lo(e) {
	return Math.floor((e + Q) / Z);
}
function $(e) {
	return e * Z - Q;
}
function uo(e, t = Date.now()) {
	let n = lo(t), r = n - e + 1;
	return {
		currentWeek: n,
		firstWeek: r,
		sinceMs: $(r)
	};
}
function fo(e, t, n = Date.now()) {
	let { currentWeek: r, firstWeek: i, sinceMs: a } = uo(t, n), o = /* @__PURE__ */ new Map();
	for (let t of e) {
		if (t.created_week < i || t.created_week > r) continue;
		let e = Math.min(Math.max(0, t.used_week - t.created_week), r - t.created_week), n = o.get(t.created_week);
		n || (n = /* @__PURE__ */ new Map(), o.set(t.created_week, n)), n.set(e, (n.get(e) ?? 0) + t.count);
	}
	let s = [];
	for (let e = i; e <= r; e++) {
		let t = o.get(e), n = r - e, i = [], a = 0;
		for (let e = n; e >= 0; e--) a += t?.get(e) ?? 0, i[e] = a;
		s.push({
			cohort: new Date($(e)).toISOString().slice(0, 10),
			sessions: i[0] ?? 0,
			active: i
		});
	}
	return {
		interval: "week",
		from: new Date(a).toISOString(),
		to: new Date(n).toISOString(),
		cohorts: s
	};
}
function po(e, t, n = Date.now()) {
	let r = fo(e, t, n);
	return {
		interval: r.interval,
		from: r.from,
		to: r.to,
		cohorts: r.cohorts.map(({ cohort: e, sessions: t, active: n }) => ({
			cohort: e,
			tokens: t,
			active: n
		}))
	};
}
//#endregion
//#region src/utils/username-validation.ts
var mo = /^[A-Za-z0-9_+\-.!#$'^`~]+$/, ho = "Username can only contain alphanumeric characters and the following characters: '_', '+', '-', '.', '!', '#', '$', \"'\", '^', '`', '~'", go = "Usernames must not contain \"@\". Use the email field for email addresses.";
function _o(e) {
	return mo.test(e);
}
function vo(e) {
	return e.toLowerCase();
}
function yo(e, t) {
	if (e.includes("@")) return go;
	if (!_o(e)) return ho;
	if (t) {
		let n = [...e].length;
		if (n < t.min) return `Username must be at least ${t.min} characters`;
		if (n > t.max) return `Username must be at most ${t.max} characters`;
	}
	return null;
}
//#endregion
//#region src/utils/feature-not-supported.ts
var bo = class extends Error {
	feature;
	adapter;
	constructor(e, t, n) {
		super(`${e} is not supported by the ${t} adapter.` + (n ? ` ${n}` : "")), this.name = "FeatureNotSupportedError", this.feature = e, this.adapter = t;
	}
};
function xo(e) {
	return e instanceof Error && e.name === "FeatureNotSupportedError";
}
//#endregion
export { Te as Auth0ActionEnum, $n as Auth0Client, S as AuthorizationResponseMode, x as AuthorizationResponseType, Y as CODE_HOOK_API_TYPE_DECLARATIONS, lt as CodeChallengeMethod, Ke as ComponentCategory, Ge as ComponentType, Da as DATABASE_CONNECTION_STRATEGY, Ee as EmailActionEnum, an as FORM_FIELD_TYPES, bo as FeatureNotSupportedError, we as FlowActionTypeEnum, Gr as GrantType, Tr as KNOWN_TENANT_OPERATION_ENGINES, er as LocationInfo, B as LogTypes, Wn as LoginSessionState, Q as MONDAY_EPOCH_SHIFT_MS, $e as NodeType, za as PRESERVE_LOCATION_HEADER, oi as RESERVED_SUBJECT_TOKEN_TYPE_PREFIXES, Ae as RedirectTargetEnum, Ta as Strategy, Ea as StrategyType, Mr as TERMINAL_TENANT_OPERATION_ROW_STATUSES, ai as TOKEN_EXCHANGE_PROFILE_TYPE, Fa as TRIGGER_API_SHAPES, Ia as TRIGGER_FUNCTION_NAMES, go as USERNAME_CONTAINS_AT_MESSAGE, ho as USERNAME_INVALID_CHARACTERS_MESSAGE, Z as WEEK_MS, o as actionDependencySchema, oe as actionExecutionErrorSchema, de as actionExecutionInsertSchema, ce as actionExecutionLogEntrySchema, le as actionExecutionLogsSchema, se as actionExecutionResultSchema, ue as actionExecutionSchema, ae as actionExecutionStatusSchema, ie as actionExecutionTriggerIdSchema, c as actionInsertSchema, nt as actionNodeSchema, re as actionResponseSchema, te as actionSchema, ne as actionSecretNameSchema, s as actionSecretSchema, a as actionTriggerSchema, ee as actionUpdateSchema, fe as actionVersionInsertSchema, pe as actionVersionSchema, oa as activeUsersResponseSchema, he as actorSchema, d as addressSchema, xn as allowedTriggersForHook, ha as analyticsColumnMetaSchema, la as analyticsGroupBySchema, ca as analyticsIntervalSchema, _a as analyticsQueryResponseSchema, sa as analyticsResourceSchema, ga as analyticsStatisticsSchema, ua as analyticsUserTypeSchema, mr as attackProtectionSchema, me as auditCategorySchema, Se as auditEventInsertSchema, Ce as auditEventSchema, xe as auth0ClientSchema, ct as auth0FlowInsertSchema, st as auth0FlowSchema, Fe as auth0QuerySchema, Oe as auth0UpdateUserActionSchema, Le as auth0UserResponseSchema, ft as authParamsSchema, Ma as authenticationMethodInsertSchema, Na as authenticationMethodSchema, ka as authenticationMethodTypeSchema, f as baseUserSchema, tn as blockComponentSchema, qr as bordersSchema, pt as brandingSchema, dr as breachedPasswordDetectionSchema, fr as bruteForceProtectionSchema, po as buildRefreshTokenRetention, fo as buildSessionRetention, Je as buttonComponentSchema, dt as claimsRequestSchema, g as clientGrantInsertSchema, He as clientGrantListSchema, _ as clientGrantSchema, h as clientInsertSchema, Ue as clientRegistrationTokenInsertSchema, We as clientRegistrationTokenSchema, v as clientRegistrationTokenTypeSchema, Ve as clientSchema, ht as codeInsertSchema, gt as codeSchema, mt as codeTypeSchema, Jr as colorsSchema, pn as componentMessageSchema, Qe as componentSchema, i as configInheritanceShape, r as configOverrideSchema, n as configScopeSchema, yt as connectionInsertSchema, vt as connectionOptionsSchema, bt as connectionSchema, y as coordinatesSchema, Ba as createPassthroughAdapter, Va as createWriteOnlyAdapter, Tt as customDomainCertificateUploadSchema, w as customDomainInsertSchema, St as customDomainSchema, Ct as customDomainUpdateSchema, wt as customDomainWithTenantIdSchema, ba as customTextEntrySchema, ya as customTextSchema, aa as dailyStatsSchema, Za as decodeBase32, Ya as decodeBase64, Ga as decodeBase64Url, qa as decodeBase64UrlString, eo as decodeCursor, _t as deviceCodeSchema, yi as emailProviderSchema, bi as emailTemplateNameSchema, xi as emailTemplateSchema, De as emailVerificationRulesSchema, ke as emailVerifyActionSchema, Xa as encodeBase32, Ja as encodeBase64, Wa as encodeBase64Url, Ka as encodeBase64UrlString, $a as encodeCursor, Qa as encodeHex, ot as endingSchema, ro as escapeLuceneValue, rn as fieldComponentSchema, Me as flowActionStepSchema, Ne as flowInsertSchema, Pe as flowSchema, Xe as flowsFieldComponentSchema, tt as flowsFlowNodeSchema, et as flowsStepNodeSchema, G as fontDetailsSchema, Yr as fontsSchema, on as formControlSchema, dn as formInsertSchema, k as formNodeComponentDefinition, un as formNodeSchema, fn as formSchema, Ze as genericComponentSchema, rt as genericNodeSchema, La as getCodeHookApiTypeDeclarations, Ha as getConnectionIdentifierConfig, Qn as getLogTypeCategory, Zn as getLogTypeDescription, Pi as grantInsertSchema, Fi as grantSchema, ni as handlerConfigSchema, Fn as hookCodeInsertSchema, In as hookCodeSchema, On as hookInsertSchema, I as hookPageId, Pn as hookSchema, L as hookTemplateId, Sn as hookTemplates, u as identitySchema, Pa as importMetadataSchema, zn as inviteInsertSchema, Bn as inviteSchema, Rn as inviteeSchema, Ln as inviterSchema, _n as isBlockComponent, Oa as isDatabaseConnectionStrategy, co as isEmailSearchTerm, xo as isFeatureNotSupportedError, yn as isFieldComponent, Ua as isPlainObject, vn as isWidgetComponent, Hn as jwksKeySchema, Vn as jwksSchema, Ye as legalComponentSchema, be as locationInfoSchema, tr as logInsertSchema, nr as logSchema, ir as logStreamFilterSchema, ar as logStreamInsertSchema, or as logStreamSchema, V as logStreamStatusSchema, rr as logStreamTypeSchema, Xn as logTypeCategories, Yn as logTypeDescriptions, z as loginSessionAuthStrategySchema, Kn as loginSessionInsertSchema, qn as loginSessionSchema, Gn as loginSessionStateSchema, ti as matchSchema, sr as migrationProviderTypeSchema, cr as migrationSourceCredentialsSchema, lr as migrationSourceInsertSchema, ur as migrationSourceSchema, it as nodeSchema, vo as normalizeUsername, Un as openIDConfigurationSchema, Ji as organizationBrandingSchema, $i as organizationConnectionInsertSchema, ta as organizationConnectionListSchema, ea as organizationConnectionSchema, Yi as organizationEnabledConnectionSchema, Zi as organizationInsertSchema, Qi as organizationSchema, Xi as organizationTokenQuotaSchema, Xr as pageBackgroundSchema, Ra as parseUserId, hr as passwordInsertSchema, gr as passwordSchema, l as profileDataSchema, xa as promptPartialInsertionPoints, wa as promptPartialsEntrySchema, Ca as promptPartialsSchema, va as promptScreenSchema, ei as promptSettingSchema, K as proxyRouteInsertSchema, ri as proxyRouteSchema, ii as proxyRouteUpdateSchema, je as redirectActionSchema, Si as refreshTokenInsertSchema, pa as refreshTokenRetentionCohortSchema, ma as refreshTokenRetentionResponseSchema, Ci as refreshTokenSchema, _e as requestAuthSchema, ve as requestContextSchema, Oi as resourceServerInsertSchema, Ai as resourceServerListSchema, Di as resourceServerOptionsSchema, ki as resourceServerSchema, Ei as resourceServerScopeSchema, ye as responseContextSchema, qe as richTextComponentSchema, Gi as roleInsertSchema, qi as roleListSchema, ji as rolePermissionInsertSchema, Ni as rolePermissionListSchema, Mi as rolePermissionSchema, Ki as roleSchema, Rr as rolloutInsertSchema, Ir as rolloutKindSchema, zr as rolloutSchema, Lr as rolloutStatusSchema, Br as rolloutUpdateSchema, oo as sanitizeLuceneQuery, pi as scimConfigurationInsertSchema, mi as scimConfigurationSchema, _i as scimExternalIdInsertSchema, vi as scimExternalIdSchema, fi as scimMappingEntrySchema, hi as scimTokenInsertSchema, gi as scimTokenSchema, mn as screenLinkSchema, _r as sessionInsertSchema, da as sessionRetentionCohortSchema, fa as sessionRetentionResponseSchema, uo as sessionRetentionWindow, vr as sessionSchema, yr as signingKeySchema, Ti as smsProviderSchema, wi as smsSendParamsSchema, ao as splitLuceneOrGroups, at as startSchema, q as subjectTokenTypeSchema, pr as suspiciousIpThrottlingSchema, ge as targetSchema, br as tenantInsertSchema, Hr as tenantMemberRequestInsertSchema, Vr as tenantMemberRequestKindSchema, Ur as tenantMemberRequestSchema, W as tenantMemberRequestStatusSchema, Wr as tenantMemberRequestUpdateSchema, wr as tenantOperationEngineSchema, Ar as tenantOperationEventInsertSchema, kr as tenantOperationEventOutcomeSchema, jr as tenantOperationEventSchema, Er as tenantOperationInsertSchema, Sr as tenantOperationKindSchema, Nr as tenantOperationRowInsertSchema, Fr as tenantOperationRowOutcomeSchema, Pr as tenantOperationRowSchema, U as tenantOperationRowStatusSchema, Dr as tenantOperationSchema, Cr as tenantOperationStatusSchema, Or as tenantOperationUpdateSchema, xr as tenantSchema, ia as tenantSettingsSchema, Qr as themeInsertSchema, $r as themeSchema, si as tokenExchangeJwtAlgorithmSchema, J as tokenExchangeJwtVerificationSchema, li as tokenExchangeProfileInsertSchema, ui as tokenExchangeProfileSchema, di as tokenExchangeProfileUpdateSchema, ci as tokenExchangeUserMappingSchema, Kr as tokenResponseSchema, to as tokenizeLuceneQuery, Ie as totalsSchema, hn as uiScreenPartialsSchema, gn as uiScreenSchema, no as unescapeLuceneValue, io as unquoteLuceneValue, Ii as userActivitySchema, p as userInsertSchema, na as userOrganizationInsertSchema, ra as userOrganizationSchema, Li as userPermissionInsertSchema, zi as userPermissionListSchema, Ri as userPermissionSchema, Vi as userPermissionWithDetailsListSchema, Bi as userPermissionWithDetailsSchema, Re as userResponseSchema, Hi as userRoleInsertSchema, Wi as userRoleListSchema, Ui as userRoleSchema, m as userSchema, _o as usernameHasOnlyAllowedCharacters, yo as validateUsername, xt as verificationMethodsSchema, lo as weekIndex, $ as weekStartMs, nn as widgetComponentSchema, Zr as widgetSchema };
